var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 903,
    height: 539,
    viewBox: "0 0 903 539",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_1002)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.001 287.876C488.587 264.178 413.562 264.178 367.447 287.876L366.835 288.212C337.147 303.697 327.039 325.344 336.437 345.063C341.433 355.556 351.963 365.513 368.004 373.705C414.431 397.409 489.462 397.409 535.583 373.705C581.704 350.001 581.447 311.575 535.026 287.871L535.001 287.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.614 276.772C498.267 246.993 403.662 246.993 345.694 276.772C344.139 277.573 342.633 278.396 341.157 279.203L344.121 280.247C345.443 279.506 346.808 278.78 348.217 278.082C404.788 249.012 497.164 249.007 554.11 278.082C611.055 307.157 611.374 354.484 554.796 383.559C498.218 412.634 405.829 412.645 348.872 383.559C327.976 372.893 314.702 359.768 309.075 345.989L305.494 346.102C311.206 360.321 324.841 373.856 346.368 384.848C404.721 414.627 499.344 414.627 557.318 384.848C615.292 355.069 614.967 306.588 556.614 276.799V276.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.675 265.943C507.652 230.208 394.062 230.208 324.492 265.943C321.635 267.412 318.894 268.917 316.269 270.458L324.161 273.225C326.423 271.915 328.774 270.632 331.215 269.375C397.105 235.514 504.683 235.514 570.996 269.375C637.308 303.237 637.682 358.35 571.792 392.211C505.901 426.073 398.317 426.078 331.986 392.211C306.786 379.347 291.125 363.418 284.984 346.73L275.457 347.039C281.794 364.847 298.404 381.891 325.3 395.622C395.341 431.384 508.938 431.384 578.52 395.622C648.102 359.86 647.704 301.683 577.675 265.921V265.943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.778 243.793C526.828 195.827 374.452 195.827 281.108 243.793C187.765 291.758 188.254 369.823 282.204 417.789C321.743 437.979 371.623 449.674 423.095 452.863L422.599 442.44C376.466 439.262 331.894 428.617 296.402 410.495C210.332 366.552 209.879 295.039 295.398 251.086C380.917 207.132 520.516 207.143 606.58 251.086C662.343 279.554 682.18 319.588 665.968 356.2L685.052 359.73C703.707 319.442 682.229 275.18 620.765 243.787L620.778 243.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.757 425.742C164.224 373.391 163.673 288.217 265.533 235.855C367.392 183.493 533.698 183.504 636.231 235.855C738.764 288.207 739.303 373.38 637.455 425.737C535.608 478.094 369.29 478.094 266.769 425.737L266.757 425.742ZM639.58 234.139C589.014 208.318 521.912 194.073 450.628 194.073C379.343 194.073 312.425 208.296 262.184 234.139C211.942 259.982 184.428 294.287 184.642 330.796C184.856 367.305 212.842 401.643 263.414 427.459C313.986 453.274 381.094 467.492 452.373 467.492C523.651 467.492 590.6 453.274 640.804 427.459C691.009 401.643 718.56 367.305 718.352 330.796C718.144 294.287 690.139 259.96 639.574 234.139H639.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.332 269.386L783.165 270.632C819.508 323.026 807.336 382.297 746.528 429.901L753.354 432.391C791.767 402.498 812.271 367.467 812.026 330.796C811.891 309.55 804.802 288.856 791.332 269.386ZM692.846 193.98C626.208 163.043 540.757 146.117 450.352 146.117C354.057 146.117 263.616 165.322 195.761 200.202C127.905 235.081 90.6802 281.471 90.9986 330.796C91.317 380.121 129.105 426.506 197.42 461.385C265.735 496.264 356.409 515.48 452.728 515.475C510.395 515.475 565.932 508.593 615.8 495.571L611.643 491.781C479.722 525.989 313.9 514.846 203.273 458.369C65.5169 388.02 64.7576 273.55 201.657 203.196C334.386 134.975 548.514 132.906 686.992 196.98L692.852 193.97L692.846 193.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.117 180.921C703.505 160.693 657.335 145.029 605.943 134.357C556.314 124.07 503.893 118.84 450.15 118.84C396.407 118.84 344.06 124.059 294.553 134.357C243.296 145.024 197.328 160.687 157.973 180.921C118.617 201.154 88.1762 224.745 67.525 251.037C47.578 276.43 37.5249 303.264 37.7392 330.791C37.9535 358.317 48.2699 385.162 68.5415 410.544C69.8558 412.197 71.2067 413.836 72.5945 415.46L80.5966 414.139C15.3125 338.095 42.9678 246.083 163.862 183.953C321.431 102.976 578.674 102.976 737.277 183.953C895.88 264.93 896.724 396.705 739.156 477.688C641.104 528.074 504.463 547.122 377.005 534.793L374.978 539.027C400.84 541.537 426.839 542.786 452.856 542.768C506.587 542.768 558.941 537.549 608.459 527.251C659.723 516.585 705.666 500.926 745.04 480.687C784.414 460.448 814.836 436.869 835.487 410.577C855.422 385.183 865.439 358.35 865.267 330.823C865.096 303.296 854.73 276.463 834.465 251.064C813.483 224.783 782.755 201.182 743.124 180.948L743.117 180.921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.707 167.244C726.476 145.175 676.113 128.077 620.025 116.447C588.219 109.881 555.944 105.24 523.424 102.553L524.036 103.945C613.351 111.525 699.14 132.906 768.054 168.105C943.77 257.805 944.676 403.765 770.142 493.465C595.608 583.165 310.649 583.17 134.958 493.465C-40.7329 403.76 -41.6452 257.81 132.907 168.105C154.452 157.116 176.928 147.62 200.132 139.701L199.569 138.38C175.966 146.413 153.108 156.064 131.205 167.244C88.2434 189.324 55.0289 215.064 32.5104 243.76C10.745 271.465 -0.183595 300.746 7.98677e-05 330.785C0.183755 360.824 11.5042 390.1 33.6186 417.81C56.5106 446.506 90.0435 472.246 133.274 494.315C176.505 516.384 226.881 533.488 282.969 545.124C337.135 556.358 394.331 562.054 452.972 562.06C511.614 562.065 568.73 556.358 622.755 545.124C678.69 533.488 728.84 516.395 771.801 494.315C814.763 472.235 847.959 446.496 870.49 417.81C892.243 390.094 903.184 360.813 902.994 330.78C902.804 300.746 891.496 271.46 869.381 243.755C846.49 215.059 812.95 189.319 769.707 167.239V167.244Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5701 265.872L398.078 111.704L507.946 168.165L206.438 322.339L96.5701 265.872Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M477.842 168.479L196.716 312.014V197.868L477.842 54.3331V168.479Z",
    fill: "#B5202E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.842 58.1123L196.716 201.647V195.448L477.579 52.1674L477.842 58.1123Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.414 198.945V311.83L196.716 313.719V200.83L200.414 198.945Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.866 57.2839V170.173L474.168 172.058V59.1681L477.866 57.2839Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.842 167.244L196.716 310.785V314.558L477.842 171.024V167.244Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.461 305.3L203.53 307.303V198.166L207.461 196.162V305.3Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.677 305.7L202.746 307.704V198.566L206.677 196.563V305.7Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.677 305.7L203.53 307.303V198.166L206.677 196.563V305.7Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.583 300.638L212.652 302.647V193.509L216.583 191.501V300.638Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.799 301.039L211.869 303.047V193.91L215.799 191.901V301.039Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.799 301.039L212.652 302.647V193.509L215.799 191.901V301.039Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.706 295.982L221.781 297.99V188.853L225.706 186.844V295.982Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.922 296.382L220.991 298.391V189.254L224.922 187.245V296.382Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.922 296.382L221.781 297.99V188.853L224.922 187.245V296.382Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.828 291.325L230.904 293.329V184.191L234.828 182.188V291.325Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.044 291.726L230.114 293.729V184.592L234.044 182.589V291.726Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.044 291.726L230.904 293.329V184.191L234.044 182.589V291.726Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.957 286.663L240.026 288.672V179.535L243.957 177.526V286.663Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.167 287.064L239.242 289.073V179.936L243.167 177.927V287.064Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.167 287.064L240.026 288.672V179.535L243.167 177.927V287.064Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.079 282.007L249.149 284.011V174.873L253.079 172.87V282.007Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.29 282.408L248.365 284.411V175.279L252.29 173.271V282.408Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.29 282.408L249.149 284.01V174.873L252.29 173.271V282.408Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.202 277.351L258.271 279.354V170.217L262.202 168.214V277.351Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.418 277.751L257.488 279.755V170.617L261.418 168.614V277.751Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.418 277.751L258.271 279.354V170.217L261.418 168.614V277.751Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.324 272.689L267.394 274.698V165.56L271.324 163.552V272.689Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.541 273.09L266.61 275.098V165.961L270.541 163.952V273.09Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.541 273.09L267.394 274.698V165.56L270.541 163.952V273.09Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.447 268.033L276.522 270.036V160.899L280.447 158.895V268.033Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.663 268.433L275.732 270.442V161.305L279.663 159.296V268.433Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.663 268.433L276.522 270.036V160.899L279.663 159.296V268.433Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.569 263.376L285.645 265.38V156.242L289.569 154.239V263.376Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.786 263.777L284.855 265.78V156.643L288.786 154.64V263.777Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.786 263.777L285.645 265.38V156.242L288.786 154.64V263.777Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.698 258.715L294.767 260.723V151.586L298.698 149.577V258.715Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.908 259.115L293.984 261.124V151.987L297.908 149.978V259.115Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.908 259.115L294.767 260.723V151.586L297.908 149.978V259.115Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.821 254.058L303.89 256.062V146.924L307.821 144.921V254.058Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.037 254.459L303.106 256.462V147.325L307.037 145.322V254.459Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.037 254.459L303.89 256.062V146.924L307.037 145.322V254.459Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.943 249.402L313.012 251.405V142.268L316.943 140.265V249.402Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.159 249.803L312.229 251.806V142.668L316.159 140.665V249.803Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.159 249.803L313.012 251.405V142.268L316.159 140.665V249.803Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.065 244.74L322.135 246.749V137.612L326.065 135.603V244.74Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.282 245.141L321.351 247.149V138.012L325.282 136.003V245.141Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.282 245.141L322.135 246.749V137.611L325.282 136.003V245.141Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.188 240.084L331.263 242.087V132.95L335.188 130.946V240.084Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.404 240.484L330.474 242.488V133.35L334.404 131.347V240.484Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.404 240.484L331.263 242.087V132.95L334.404 131.347V240.484Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.317 235.422L340.386 237.431V128.293L344.317 126.285V235.422Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.527 235.828L339.596 237.831V128.694L343.527 126.691V235.828Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.527 235.828L340.386 237.431V128.293L343.527 126.691V235.828Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.439 230.766L349.509 232.774V123.637L353.439 121.628V230.766Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.649 231.166L348.725 233.175V124.038L352.649 122.029V231.166Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.649 231.166L349.509 232.774V123.637L352.649 122.029V231.166Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.562 226.109L358.631 228.113V118.975L362.562 116.972V226.109Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.772 226.51L357.847 228.513V119.376L361.772 117.373V226.51Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.772 226.51L358.631 228.113V118.975L361.772 117.373V226.51Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.684 221.448L367.753 223.456V114.319L371.684 112.31V221.448Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.9 221.854L366.97 223.857V114.72L370.9 112.716V221.854Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.9 221.854L367.753 223.456V114.319L370.9 112.716V221.854Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.807 216.791L376.882 218.8V109.657L380.807 107.654V216.791Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.023 217.192L376.092 219.201V110.063L380.023 108.054V217.192Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.023 217.192L376.882 218.8V109.657L380.023 108.054V217.192Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.929 212.135L386.005 214.138V105.001L389.929 102.997V212.135Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.145 212.535L385.215 214.539V105.401L389.145 103.398V212.535Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.145 212.535L386.005 214.138V105.001L389.145 103.398V212.535Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.052 207.473L395.127 209.482V100.344L399.052 98.3357V207.473Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.268 207.879L394.344 209.882V100.745L398.268 98.7363V207.879Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.268 207.879L395.127 209.482V100.344L398.268 98.7363V207.879Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.18 202.817L404.25 204.825V95.6826L408.18 93.6793V202.817Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.391 203.217L403.466 205.226V96.0887L407.391 94.08V203.217Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.391 203.217L404.25 204.825V95.6826L407.391 94.08V203.217Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.303 198.16L413.372 200.164V91.0263L417.303 89.0229V198.16Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.513 198.561L412.589 200.564V91.427L416.513 89.4237V198.561Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.513 198.561L413.372 200.164V91.0264L416.513 89.4237V198.561Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.425 193.499L422.495 195.507V86.3699L426.425 84.3612V193.499Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.642 193.899L421.711 195.908V86.7706L425.642 84.7618V193.899Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.642 193.899L422.495 195.507V86.3699L425.642 84.7618V193.899Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.548 188.842L431.623 190.845V81.7081L435.548 79.7048V188.842Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.764 189.243L430.833 191.252V82.1142L434.764 80.1055V189.243Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.764 189.243L431.623 190.845V81.7081L434.764 80.1055V189.243Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.67 184.186L440.746 186.189V77.0518L444.67 75.0485V184.186Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.887 184.587L439.956 186.59V77.4525L443.887 75.4492V184.587Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.887 184.587L440.746 186.189V77.0519L443.887 75.4492V184.587Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.799 179.524L449.868 181.533V72.3955L453.799 70.3867V179.524Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.009 179.925L449.085 181.933V72.7961L453.009 70.7874V179.925Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.009 179.925L449.868 181.533V72.3954L453.009 70.7874V179.925Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.921 174.868L458.991 176.871V67.7337L462.921 65.7303V174.868Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.132 175.268L458.207 177.277V68.1344L462.132 66.1311V175.268Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.132 175.268L458.991 176.871V67.7338L462.132 66.1311V175.268Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.044 170.211L468.113 172.215V63.0774L472.044 61.0741V170.211Z",
    fill: "#A51D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.26 170.612L467.33 172.615V63.478L471.26 61.4747V170.612Z",
    fill: "#F06477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.26 170.612L468.113 172.215V63.0774L471.26 61.4747V170.612Z",
    fill: "#C6263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.716 202.286L204.314 198.409V191.571L196.716 195.448V202.286Z",
    fill: "#D22434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.634 198.723C200.908 198.565 201.136 198.353 201.299 198.103C201.463 197.852 201.558 197.572 201.577 197.283V195.794C201.577 195.253 201.154 195.052 200.634 195.318C200.361 195.476 200.134 195.688 199.971 195.939C199.808 196.189 199.714 196.47 199.697 196.758V198.241C199.697 198.772 200.12 198.989 200.634 198.723Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.716 310.146L204.314 306.264V313.102L196.716 316.984V310.146Z",
    fill: "#D22434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.634 309.696C201.154 309.431 201.577 309.647 201.577 310.178V311.662C201.559 311.951 201.464 312.233 201.301 312.484C201.137 312.735 200.909 312.949 200.634 313.107C200.12 313.373 199.697 313.156 199.697 312.625V311.142C199.715 310.853 199.809 310.572 199.972 310.321C200.135 310.07 200.361 309.856 200.634 309.696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.25 62.628L477.842 58.7513V51.913L470.25 55.7897V62.628Z",
    fill: "#D22434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.169 59.0653C474.443 58.9068 474.671 58.6933 474.835 58.4421C474.999 58.191 475.094 57.9092 475.111 57.6197V56.1362C475.111 55.5947 474.689 55.3944 474.169 55.6543C473.895 55.8138 473.667 56.0275 473.504 56.2785C473.34 56.5294 473.245 56.8107 473.226 57.0999V58.5835C473.226 59.1141 473.66 59.3306 474.169 59.0653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.275 170.471L477.866 166.595V173.433L470.275 177.31V170.471Z",
    fill: "#D22434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.193 170.027C474.714 169.762 475.136 169.979 475.136 170.509V171.993C475.117 172.281 475.022 172.562 474.858 172.812C474.695 173.062 474.467 173.275 474.193 173.433C473.673 173.698 473.25 173.482 473.25 172.951V171.468C473.268 171.179 473.363 170.898 473.526 170.647C473.69 170.397 473.919 170.185 474.193 170.027Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.132 169.508V289.614L115.929 274.189L114.968 269.441L104.095 263.891L103.023 267.6L95.3884 263.707V143.6L146.132 169.508Z",
    fill: "#AD1F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.138 281.119L96.8579 255.959V151.315L146.138 176.476V281.119Z",
    fill: "#414242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.366 279.766L98.1558 255.661V152.945L145.366 177.05V279.766Z",
    fill: "#AD1F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.581 273.128L101.358 252.077V159.74L142.581 180.791V273.128Z",
    fill: "#AD1F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.66 273.247L101.272 252.131V159.615L142.66 180.732V273.247ZM101.413 252.033L142.477 273.003V180.829L101.413 159.87V252.033Z",
    fill: "#981B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8579 259.169L95.1375 258.298V150.438L96.8579 151.315V259.169Z",
    fill: "#C52231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.409 190.456L101.45 169.54V162.956L142.409 183.872V190.456Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.409 189.541L101.45 168.625V164.088L142.409 184.998V189.541Z",
    fill: "#A71E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.409 210.955L101.45 190.039V183.455L142.409 204.371V210.955Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.409 210.039L101.45 189.124V184.587L142.409 205.497V210.039Z",
    fill: "#A71E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.409 248.736L101.45 227.82V221.236L142.409 242.152V248.736Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.409 247.821L101.45 226.905V222.363L142.409 243.278V247.821Z",
    fill: "#A71E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.409 269.435L101.45 248.519V241.935L142.409 262.851V269.435Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.409 268.52L101.45 247.604V243.067L142.409 263.977V268.52Z",
    fill: "#A71E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2701 255.585L97.0416 254.448C96.5612 254.169 96.1613 253.795 95.8742 253.355C95.5871 252.915 95.4207 252.421 95.3884 251.914C95.3884 250.988 96.1294 250.609 97.0416 251.069L99.2701 252.212C99.7497 252.49 100.149 252.864 100.436 253.303C100.723 253.742 100.89 254.234 100.923 254.74C100.923 255.672 100.189 256.051 99.2701 255.585Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8579 254.768L95.1375 253.89V249.835L96.8579 250.712V254.768Z",
    fill: "#A31E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2701 225.135L97.0416 223.998C96.5612 223.719 96.1613 223.345 95.8742 222.905C95.5871 222.465 95.4207 221.971 95.3884 221.464C95.3884 220.538 96.1294 220.159 97.0416 220.619L99.2701 221.762C99.7497 222.04 100.149 222.413 100.436 222.852C100.723 223.291 100.89 223.784 100.923 224.29C100.923 225.221 100.189 225.6 99.2701 225.135Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8579 224.317L95.1375 223.44V219.385L96.8579 220.262V224.317Z",
    fill: "#A31E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2701 187.353L97.0416 186.216C96.5612 185.938 96.1613 185.563 95.8742 185.123C95.5871 184.683 95.4207 184.19 95.3884 183.682C95.3884 182.757 96.1294 182.378 97.0416 182.838L99.2701 183.98C99.7497 184.258 100.149 184.632 100.436 185.071C100.723 185.51 100.89 186.002 100.923 186.509C100.923 187.44 100.189 187.819 99.2701 187.353Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8579 186.536L95.1375 185.659V181.603L96.8579 182.48V186.536Z",
    fill: "#A31E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2701 156.887L97.0416 155.75C96.5612 155.471 96.1613 155.097 95.8742 154.657C95.5871 154.216 95.4207 153.723 95.3884 153.216C95.3884 152.29 96.1294 151.911 97.0416 152.371L99.2701 153.514C99.7505 153.792 100.15 154.167 100.437 154.607C100.724 155.047 100.891 155.54 100.923 156.047C100.923 156.973 100.189 157.352 99.2701 156.887Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8579 156.069L95.1375 155.192V151.137L96.8579 152.014V156.069Z",
    fill: "#A31E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.735 154.315L95.1375 150.438V143.6L102.735 147.477V154.315Z",
    fill: "#C52231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8108 150.752C98.5368 150.594 98.3087 150.382 98.1449 150.132C97.9811 149.881 97.8861 149.601 97.8679 149.312V147.828C97.8679 147.287 98.2965 147.081 98.8108 147.346C99.0845 147.505 99.3124 147.717 99.4761 147.967C99.6399 148.217 99.735 148.498 99.7537 148.787V150.276C99.7537 150.801 99.3312 151.017 98.8108 150.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.735 269.013L95.1375 265.136V258.298L102.735 262.174V269.013Z",
    fill: "#C52231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8108 265.45C98.5373 265.291 98.3098 265.077 98.1461 264.826C97.9824 264.575 97.8871 264.294 97.8679 264.004V262.521C97.8679 261.979 98.2965 261.774 98.8108 262.039C99.0853 262.198 99.3137 262.411 99.4775 262.662C99.6413 262.913 99.7359 263.195 99.7537 263.485V264.968C99.7537 265.499 99.3312 265.715 98.8108 265.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.709 169.291V289.398L175.918 304.818L176.879 301.055L187.746 306.599L188.824 311.407L196.459 315.306V194.89L145.709 169.291Z",
    fill: "#AD1F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.709 280.903L194.989 306.063V201.42L145.709 176.259V280.903Z",
    fill: "#414242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.48 280.334L193.685 304.434V201.718L146.48 177.618V280.334Z",
    fill: "#AD1F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.266 276.539L190.489 297.59V205.248L149.266 184.202V276.539Z",
    fill: "#AD1F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.168 184.078L190.557 205.194V297.693L149.168 276.577V184.078ZM190.397 205.291L149.334 184.321V276.495L190.397 297.465V205.291Z",
    fill: "#981B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.989 309.274L196.703 310.151V202.297L194.989 201.42V309.274Z",
    fill: "#C52231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.432 194.04L190.397 214.956V208.372L149.432 187.456V194.04Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.432 193.125L190.397 214.041V209.498L149.432 188.588V193.125Z",
    fill: "#A71E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.432 214.539L190.397 235.455V228.871L149.432 207.955V214.539Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.432 213.624L190.397 234.539V229.997L149.432 209.081V213.624Z",
    fill: "#A71E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.432 252.32L190.397 273.236V266.652L149.432 245.736V252.32Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.432 251.405L190.397 272.321V267.778L149.432 246.863V251.405Z",
    fill: "#A71E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.432 273.019L190.397 293.935V287.351L149.432 266.435V273.019Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.432 272.104L190.397 293.02V288.477L149.432 267.567V272.104Z",
    fill: "#A71E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.571 303.221L194.799 304.363C195.711 304.823 196.452 304.444 196.452 303.518C196.42 303.011 196.254 302.518 195.966 302.078C195.679 301.638 195.28 301.263 194.799 300.985L192.571 299.848C191.658 299.382 190.917 299.761 190.917 300.687C190.95 301.194 191.116 301.687 191.403 302.128C191.69 302.568 192.09 302.942 192.571 303.221Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.989 304.872L196.703 305.749V301.694L194.989 300.817V304.872Z",
    fill: "#A31E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.571 272.77L194.799 273.913C195.711 274.373 196.452 273.994 196.452 273.068C196.42 272.561 196.254 272.067 195.966 271.627C195.679 271.187 195.28 270.813 194.799 270.534L192.571 269.397C191.658 268.932 190.917 269.31 190.917 270.242C190.951 270.748 191.118 271.24 191.405 271.68C191.692 272.119 192.091 272.492 192.571 272.77Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.989 274.422L196.703 275.299V271.243L194.989 270.366V274.422Z",
    fill: "#A31E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.571 234.989L194.799 236.131C195.711 236.591 196.452 236.212 196.452 235.287C196.42 234.779 196.254 234.286 195.966 233.846C195.679 233.406 195.28 233.031 194.799 232.753L192.571 231.616C191.658 231.15 190.917 231.529 190.917 232.46C190.951 232.967 191.118 233.459 191.405 233.898C191.692 234.337 192.091 234.711 192.571 234.989Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.989 236.64L196.703 237.517V233.462L194.989 232.585V236.64Z",
    fill: "#A31E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.571 204.522L194.799 205.665C195.711 206.13 196.452 205.746 196.452 204.82C196.42 204.313 196.254 203.819 195.966 203.379C195.679 202.939 195.28 202.565 194.799 202.286L192.571 201.149C191.658 200.683 190.917 201.062 190.917 201.994C190.951 202.5 191.118 202.992 191.405 203.432C191.692 203.871 192.091 204.244 192.571 204.522Z",
    fill: "#991C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.989 206.174L196.703 207.051V202.995L194.989 202.118V206.174Z",
    fill: "#A31E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.112 198.415L196.703 202.297V195.459L189.112 191.576V198.415Z",
    fill: "#C52231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.03 198.853C193.55 199.119 193.973 198.902 193.973 198.371V196.888C193.956 196.599 193.861 196.318 193.697 196.068C193.533 195.817 193.305 195.605 193.03 195.448C192.509 195.182 192.087 195.399 192.087 195.924V197.413C192.106 197.702 192.201 197.982 192.365 198.233C192.528 198.483 192.756 198.695 193.03 198.853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.112 313.113L196.703 316.989V310.151L189.112 306.274V313.113Z",
    fill: "#C52231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.03 313.557C193.55 313.822 193.973 313.605 193.973 313.075V311.591C193.955 311.302 193.861 311.02 193.697 310.769C193.533 310.518 193.304 310.304 193.03 310.146C192.509 309.88 192.087 310.097 192.087 310.628V312.111C192.105 312.401 192.199 312.682 192.363 312.934C192.527 313.185 192.755 313.398 193.03 313.557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.115 144.482L378.241 0.942139L477.842 51.913L196.734 195.345L97.115 144.482Z",
    fill: "#DD263E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.739 7.06574L372.67 5.05701L471.046 55.2861L467.115 57.2948L368.739 7.06574Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.523 6.6651L373.454 4.65637L471.83 54.8854L467.899 56.8942L369.523 6.6651Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.523 6.66507L372.67 5.05701L471.046 55.2861L467.899 56.8941L369.523 6.66507Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.617 11.7221L363.541 9.71875L461.924 59.9478L457.993 61.9511L359.617 11.7221Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.4 11.3215L364.331 9.31274L462.707 59.5418L458.777 61.5505L360.4 11.3215Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.4 11.3214L363.541 9.71875L461.923 59.9478L458.777 61.5505L360.4 11.3214Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.494 16.3784L354.419 14.3751L452.795 64.6042L448.87 66.6075L350.494 16.3784Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.278 15.9778L355.208 13.9745L453.585 64.2036L449.654 66.2069L351.278 15.9778Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.278 15.9778L354.419 14.3751L452.795 64.6042L449.654 66.2068L351.278 15.9778Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.366 21.0402L345.296 19.0315L443.673 69.2606L439.748 71.2693L341.366 21.0402Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.155 20.6396L346.08 18.6309L444.462 68.8599L440.531 70.8686L342.155 20.6396Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.155 20.6396L345.296 19.0315L443.672 69.2606L440.531 70.8686L342.155 20.6396Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.243 25.6966L336.174 23.6932L434.55 73.9223L430.619 75.9256L332.243 25.6966Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.033 25.2959L336.957 23.2926L435.334 73.5162L431.409 75.525L333.033 25.2959Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.033 25.2959L336.174 23.6932L434.55 73.9223L431.409 75.525L333.033 25.2959Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.121 30.3529L327.051 28.3496L425.427 78.5787L421.497 80.582L323.121 30.3529Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.904 29.9523L327.835 27.949L426.211 78.178L422.287 80.1814L323.904 29.9523Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.904 29.9523L327.051 28.3496L425.427 78.5787L422.287 80.1813L323.904 29.9523Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.998 35.0147L317.929 33.006L416.305 83.235L412.374 85.2438L313.998 35.0147Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.782 34.6141L318.712 32.6053L417.089 82.8344L413.158 84.8431L314.782 34.6141Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.782 34.614L317.929 33.006L416.305 83.2351L413.158 84.8431L314.782 34.614Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.875 39.671L308.806 37.6677L407.182 87.8968L403.252 89.9001L304.875 39.671Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.659 39.2704L309.59 37.2671L407.966 87.4907L404.035 89.4995L305.659 39.2704Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.659 39.2704L308.806 37.6677L407.182 87.8968L404.035 89.4994L305.659 39.2704Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.753 44.3328L299.677 42.3241L398.054 92.5532L394.129 94.5565L295.753 44.3328Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.537 43.9268L300.467 41.9235L398.843 92.1525L394.913 94.1558L296.537 43.9268Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.537 43.9267L299.677 42.3241L398.054 92.5532L394.913 94.1558L296.537 43.9267Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.624 48.9892L290.555 46.9805L388.931 97.2095L385.007 99.2183L286.624 48.9892Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.414 48.5886L291.345 46.5798L389.721 96.8089L385.79 98.8176L287.414 48.5886Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.414 48.5885L290.555 46.9805L388.931 97.2095L385.79 98.8176L287.414 48.5885Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.502 53.6455L281.433 51.6422L379.809 101.871L375.878 103.875L277.502 53.6455Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.292 53.2449L282.216 51.2416L380.592 101.471L376.668 103.474L278.292 53.2449Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.292 53.2449L281.433 51.6422L379.809 101.871L376.668 103.474L278.292 53.2449Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.379 58.3073L272.31 56.2986L370.686 106.528L366.756 108.531L268.379 58.3073Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.163 57.9013L273.094 55.8979L371.47 106.127L367.545 108.13L269.163 57.9013Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.163 57.9012L272.31 56.2986L370.686 106.528L367.545 108.13L269.163 57.9012Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.257 62.9637L263.187 60.955L361.564 111.184L357.633 113.193L259.257 62.9637Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.041 62.5629L263.971 60.5542L362.347 110.783L358.417 112.792L260.041 62.5629Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.041 62.563L263.187 60.955L361.564 111.184L358.417 112.792L260.041 62.563Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.134 67.62L254.059 65.6167L352.441 115.846L348.51 117.849L250.134 67.62Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.918 67.2194L254.849 65.2161L353.225 115.445L349.294 117.448L250.918 67.2194Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.918 67.2194L254.059 65.6167L352.441 115.846L349.294 117.448L250.918 67.2194Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.012 72.2818L244.936 70.2731L343.319 120.502L339.388 122.505L241.012 72.2818Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.795 71.8756L245.726 69.8723L344.102 120.101L340.172 122.105L241.795 71.8756Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.795 71.8757L244.936 70.2731L343.319 120.502L340.172 122.105L241.795 71.8757Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.889 76.9382L235.814 74.9294L334.19 125.159L330.266 127.167L231.889 76.9382Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.673 76.5374L236.598 74.5287L334.98 124.758L331.049 126.766L232.673 76.5374Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.673 76.5375L235.814 74.9294L334.19 125.159L331.049 126.767L232.673 76.5375Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.761 81.5945L226.691 79.5912L325.068 129.82L321.137 131.824L222.761 81.5945Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.551 81.1938L227.475 79.1904L325.857 129.419L321.927 131.423L223.551 81.1938Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.551 81.1938L226.691 79.5912L325.068 129.82L321.927 131.423L223.551 81.1938Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.638 86.2563L217.569 84.2476L315.945 134.477L312.014 136.48L213.638 86.2563Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.428 85.8501L218.352 83.8468L316.729 134.076L312.804 136.079L214.428 85.8501Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.428 85.8502L217.569 84.2476L315.945 134.477L312.804 136.079L214.428 85.8502Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.516 90.9125L208.446 88.9038L306.822 139.133L302.892 141.142L204.516 90.9125Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.299 90.5119L209.23 88.5032L307.606 138.732L303.675 140.741L205.299 90.5119Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.299 90.5119L208.446 88.9038L306.822 139.133L303.675 140.741L205.299 90.5119Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.393 95.5689L199.324 93.5656L297.7 143.795L293.769 145.798L195.393 95.5689Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.177 95.1682L200.107 93.1649L298.484 143.394L294.553 145.397L196.177 95.1682Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.177 95.1682L199.324 93.5656L297.7 143.795L294.553 145.397L196.177 95.1682Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.271 100.231L190.195 98.222L288.571 148.451L284.647 150.454L186.271 100.231Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.054 99.83L190.985 97.8213L289.361 148.05L285.43 150.054L187.054 99.83Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.054 99.8301L190.195 98.222L288.571 148.451L285.43 150.054L187.054 99.8301Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.142 104.887L181.073 102.878L279.449 153.107L275.524 155.116L177.142 104.887Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.932 104.486L181.863 102.478L280.239 152.707L276.308 154.715L177.932 104.486Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.932 104.486L181.073 102.878L279.449 153.107L276.308 154.715L177.932 104.486Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.02 109.543L171.95 107.54L270.326 157.769L266.402 159.773L168.02 109.543Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.809 109.143L172.734 107.139L271.11 157.368L267.186 159.372L168.809 109.143Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.809 109.143L171.95 107.54L270.326 157.769L267.186 159.372L168.809 109.143Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.897 114.205L162.828 112.196L261.204 162.425L257.273 164.429L158.897 114.205Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.687 113.805L163.611 111.796L261.987 162.025L258.063 164.028L159.687 113.805Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.687 113.804L162.828 112.196L261.204 162.425L258.063 164.028L159.687 113.804Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.774 118.862L153.705 116.853L252.081 167.082L248.151 169.091L149.774 118.862Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.558 118.461L154.489 116.452L252.865 166.681L248.94 168.69L150.558 118.461Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.558 118.461L153.705 116.853L252.081 167.082L248.94 168.69L150.558 118.461Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.652 123.518L144.582 121.515L242.959 171.744L239.028 173.747L140.652 123.518Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.436 123.117L145.366 121.114L243.742 171.343L239.812 173.346L141.436 123.117Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.436 123.117L144.583 121.515L242.959 171.744L239.812 173.346L141.436 123.117Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.53 128.18L135.454 126.171L233.836 176.4L229.906 178.409L131.53 128.18Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.313 127.779L136.244 125.77L234.62 175.999L230.689 178.003L132.313 127.779Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.313 127.779L135.454 126.171L233.836 176.4L230.689 178.003L132.313 127.779Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.407 132.836L126.332 130.827L224.708 181.056L220.783 183.065L122.407 132.836Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.191 132.435L127.121 130.427L225.497 180.656L221.567 182.664L123.191 132.435Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.191 132.435L126.332 130.827L224.708 181.056L221.567 182.664L123.191 132.435Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.278 137.492L117.209 135.489L215.585 185.718L211.654 187.721L113.278 137.492Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.068 137.092L117.993 135.088L216.369 185.317L212.444 187.321L114.068 137.092Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.068 137.092L117.209 135.489L215.585 185.718L212.444 187.321L114.068 137.092Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.156 142.154L108.086 140.145L206.463 190.374L202.532 192.383L104.156 142.154Z",
    fill: "#C6213D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.946 141.753L108.87 139.745L207.246 189.974L203.322 191.977L104.946 141.753Z",
    fill: "#F16D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.946 141.753L108.086 140.145L206.463 190.374L203.322 191.977L104.946 141.753Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.262 193.569L474.334 50.0667L477.842 51.9129L196.96 195.459L193.262 193.569Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.526 48.0634L462.928 51.94L470.507 55.8113L477.842 51.913L470.526 48.0634Z",
    fill: "#ED2C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.869 187.781L189.271 191.663L196.857 195.534L204.448 191.652L196.869 187.781Z",
    fill: "#ED2C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9394 145.435L380.066 1.89506L376.368 0.0108643L95.2415 143.546L98.9394 145.435Z",
    fill: "#E32D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.137 3.9579L376.545 7.83459L368.794 3.87669L376.392 0L384.137 3.9579Z",
    fill: "#ED2C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.487 143.676L102.889 147.558L95.1375 143.6L102.735 139.723L110.487 143.676Z",
    fill: "#ED2C3C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.447 379.899L413.09 353.103L445.423 369.801L393.786 396.597L361.447 379.899Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.035 319.199C409.105 318.5 409.601 317.341 411.26 316.491C411.462 316.394 411.664 316.302 411.872 316.215L412.393 316.031C412.976 315.848 413.583 315.726 414.199 315.668C414.987 315.573 415.79 315.642 416.544 315.869L413.409 317.493L416.886 319.269C417.005 319.322 417.136 319.35 417.269 319.35C417.402 319.35 417.533 319.322 417.652 319.269C417.698 319.255 417.738 319.229 417.766 319.194C417.795 319.159 417.81 319.117 417.81 319.074C417.81 319.031 417.795 318.989 417.766 318.954C417.738 318.919 417.698 318.893 417.652 318.879L417.529 318.814C417.513 318.81 417.498 318.801 417.488 318.789C417.477 318.777 417.472 318.762 417.472 318.746C417.472 318.731 417.477 318.716 417.488 318.704C417.498 318.692 417.513 318.683 417.529 318.679C417.571 318.66 417.617 318.65 417.664 318.65C417.711 318.65 417.757 318.66 417.799 318.679L417.921 318.738C418 318.762 418.068 318.807 418.116 318.867C418.164 318.926 418.19 318.998 418.19 319.071C418.19 319.145 418.164 319.216 418.116 319.276C418.068 319.336 418 319.38 417.921 319.404C417.719 319.495 417.496 319.542 417.269 319.542C417.043 319.542 416.819 319.495 416.617 319.404L413.139 317.628L410.035 319.199Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.903 318.002L414.474 313.627L423.046 318.002L414.474 322.377L405.903 318.002ZM414.474 313.963L406.57 318.002L414.474 322.036L422.385 318.002L414.474 313.963Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.591 322.756L405.162 318.381L413.734 322.756L405.162 327.13L396.591 322.756ZM405.162 318.717L397.258 322.756L405.162 326.795L413.072 322.756L405.162 318.717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.54 322.014L402.701 323.097C403.097 323.276 403.535 323.369 403.98 323.369C404.425 323.369 404.864 323.276 405.26 323.097L405.799 322.826C405.953 322.779 406.087 322.691 406.181 322.573C406.276 322.456 406.327 322.315 406.327 322.171C406.327 322.027 406.276 321.886 406.181 321.769C406.087 321.651 405.953 321.563 405.799 321.516L403.637 320.433L402.07 321.234L403.044 321.38L402.376 321.722L405.223 322.263L401.55 321.917L402.229 321.57H401.482L400.54 322.014Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.629 324.299L408.101 324.055L405.395 322.674L404.923 322.918L407.629 324.299Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.648 324.066L409.791 323.497L406.613 325.122L407.648 324.066Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.364 327.466L395.935 323.091L404.507 327.466L395.935 331.841L387.364 327.466ZM395.935 323.427L388.031 327.466L395.935 331.5L403.845 327.466L395.935 323.427Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.929 325.896L402.437 327.25L395.519 330.785L392.929 325.896ZM393.725 326.307L395.807 330.233L401.366 327.396L393.725 326.307Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.072 328.555C397.978 328.599 397.873 328.622 397.766 328.622C397.659 328.622 397.554 328.599 397.46 328.555C397.282 328.457 397.264 328.332 397.46 328.24C397.554 328.195 397.659 328.172 397.766 328.172C397.873 328.172 397.978 328.195 398.072 328.24C398.231 328.332 398.25 328.462 398.072 328.555ZM396.848 328.116L394.356 326.914L394.839 326.665L397.191 327.937L396.848 328.116Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.149 332.188L386.721 327.813L395.292 332.188L386.721 336.562L378.149 332.188ZM386.721 328.148L378.817 332.188L386.721 336.227L394.625 332.188L386.721 328.148Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.143 335.252L392.69 332.42L391.882 332.003L386.329 334.841L387.143 335.252Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.623 334.142L387.266 333.812L383.115 331.689L382.472 332.02L386.623 334.142Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.515 332.621L384.29 331.716L381.762 331.413L382.515 332.621Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.721 332.561L390.364 332.231L386.207 330.114L385.564 330.439L389.721 332.561Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.613 331.04L387.388 330.135L384.854 329.832L385.613 331.04Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.429 318.592L386.084 340.369V392.644L343.429 370.862V318.592Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.429 318.592L386.084 340.369V340.612L343.429 318.901V318.592Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.746 318.592L386.084 340.369V392.644L428.746 370.862V318.592Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.429 318.592L386.084 340.369L428.746 318.592L386.084 296.81L343.429 318.592Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M411.682 309.875L369.033 331.662L360.492 327.304L403.148 305.522L411.682 309.875Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M369.033 331.662L369.021 349.08L360.492 344.727V327.304L369.033 331.662Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M369.033 366.515L369.021 383.933L360.492 379.574V362.151L369.033 366.515Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M360.492 309.875L403.135 331.662L411.682 327.304L369.021 305.522L360.492 309.875Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M403.135 331.662L403.148 349.08L411.682 344.727V327.304L403.135 331.662Z",
    fill: "#D5C3A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M403.135 366.515L403.148 383.933L411.682 379.574V362.151L403.135 366.515Z",
    fill: "#D5C3A9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.016 366.617L546.659 339.822L578.992 356.52L527.348 383.315L495.016 366.617Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M494.495 349.08L520.087 362.151V379.574L494.495 366.509V349.08Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.495 349.08L520.087 362.151V362.394L494.495 349.394V349.08Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.749 340.369L520.087 362.151V379.574L562.749 357.792V340.369Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.495 349.08L520.087 362.151L562.749 340.369L537.151 327.304L494.495 349.08Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M554.214 336.015L511.571 357.803L503.024 353.439L545.685 331.657L554.214 336.015Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M511.571 357.803L511.559 366.509L503.024 362.151V353.439L511.571 357.803Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.546 423.539L500.189 396.748L532.522 413.446L480.885 440.242L448.546 423.539Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.513 388.367L473.232 418.861V436.279L413.513 405.79V388.367Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.513 388.367L473.232 418.861V419.104L413.513 388.676V388.367Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.893 397.079L473.232 418.861V436.279L515.893 414.502V397.079Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.513 388.367L473.232 418.861L515.893 397.079L456.168 366.585L413.513 388.367Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M490.301 384.008L447.652 405.796L439.105 401.432L481.766 379.65L490.301 384.008Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M430.576 379.65L490.301 410.16L498.842 405.796L439.111 375.297L430.576 379.65Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M490.289 410.154L490.301 418.855L498.836 414.502V405.79L490.289 410.154Z",
    fill: "#DDC8AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.007 407.404C435.75 405.882 434.115 403.977 432.131 402.964C431.911 402.849 431.682 402.748 431.446 402.661C431.276 402.595 431.102 402.537 430.925 402.488C430.445 402.342 429.931 402.307 429.431 402.385C429.134 402.433 428.862 402.565 428.655 402.76C428.448 402.954 428.317 403.202 428.28 403.468L431.991 405.368V409.575C431.991 409.829 431.789 409.932 431.537 409.808C431.408 409.731 431.3 409.628 431.222 409.508C431.145 409.387 431.1 409.253 431.091 409.115V408.931C431.088 408.881 431.071 408.833 431.042 408.791C431.013 408.748 430.973 408.713 430.925 408.687C430.84 408.638 430.766 408.687 430.766 408.768V408.914C430.781 409.151 430.859 409.381 430.993 409.586C431.127 409.791 431.314 409.965 431.537 410.095C431.966 410.311 432.309 410.138 432.309 409.7V405.493L436.007 407.404Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.066 414.399L426.909 409.212V398.844L437.066 404.031V414.399ZM427.307 409.012L436.674 413.798V404.231L427.307 399.45V409.012Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.099 420.03L437.942 414.849V404.48L448.099 409.662V420.03ZM438.34 414.648L447.701 419.429V409.862L438.34 405.081V414.648Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.885 409.537V412.179C444.885 413.035 444.199 413.381 443.366 412.959L442.754 412.634C442.313 412.378 441.946 412.034 441.682 411.629C441.419 411.225 441.266 410.772 441.236 410.306V407.691L443.072 408.638L442.668 409.18L443.458 409.586L442.381 411.378L444.15 409.656L443.342 409.245L443.758 408.974L444.885 409.537Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.354 415.742L442.791 415.455V412.179L443.354 412.466V415.742Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.072 415.336L441.138 414.973L444.903 416.895L443.072 415.336Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.028 425.612L448.87 420.425V410.057L459.028 415.244V425.612ZM449.268 420.198L458.63 424.979V415.428L449.268 410.642V420.198Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.048 423.604L449.85 419.418L453.909 414.139L458.048 423.604ZM450.652 419.348L457.24 422.716L453.915 415.103L450.652 419.348Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.597 419.857C453.597 419.635 453.744 419.554 453.946 419.657C454.051 419.714 454.139 419.793 454.201 419.888C454.263 419.982 454.297 420.089 454.301 420.198C454.301 420.415 454.166 420.507 453.946 420.398C453.843 420.339 453.758 420.259 453.697 420.165C453.637 420.071 453.602 419.965 453.597 419.857ZM453.744 419.061L453.664 416.089L454.234 416.381L454.154 419.267L453.744 419.061Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.987 431.205L459.836 426.019V415.65L469.987 420.842V431.205ZM460.228 425.791L469.595 430.577V421.01L460.228 416.229V425.791Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.193 429.013L461.617 425.656V424.67L468.193 428.027V429.013Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.207 426.879L466.448 426.489V421.46L467.207 421.849V426.879Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.881 422.938L465.775 421.86L466.926 420.555L467.881 422.938Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.546 425.006L462.781 424.616V419.592L463.546 419.976V425.006Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.219 421.064L462.113 419.992L463.258 418.682L464.219 421.064Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M447.652 405.796L447.64 414.497L439.105 410.144V401.432L447.652 405.796Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.209 460.481L405.291 442.029L471.389 476.101L436.307 494.553L403.974 477.856L370.209 460.481Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.603 443.041L429.327 473.535V490.958L369.603 460.465V443.041Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.603 443.041L429.327 473.535V473.779L369.603 443.355V443.041Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.907 460.481L429.327 473.535V490.958L454.907 477.904V460.481Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.603 443.041L429.327 473.535L454.907 460.481L395.188 429.976L369.603 443.041Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M378.137 438.683L437.856 469.193L446.403 464.829L386.666 434.329L378.137 438.683Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M437.85 469.187L437.862 477.888L446.397 473.535V464.823L437.85 469.187Z",
    fill: "#DDC8AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M731.564 389.455L721.921 390.181L693.684 376.011L709.089 368.642L731.564 389.455Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.966 350.25L731.564 363.32V389.455L705.966 376.385V350.25Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.966 350.25L731.564 363.32V363.564L705.966 350.564V350.25Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.156 350.25L731.564 363.32V389.455L757.156 376.385V350.25Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.966 350.25L731.564 363.32L757.156 350.25L731.564 337.18L705.966 350.25Z",
    fill: "#BA905E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.564 363.32L757.156 350.25L731.564 337.18V363.32Z",
    fill: "#855C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.966 350.25L691.652 351.706L717.501 338.993L731.564 337.18L705.966 350.25Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.564 337.169L742.934 335.117L768.305 348.333L757.156 350.239L731.564 337.169Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.431 359.514L705.966 350.25L731.564 363.32L723.146 372.378L697.431 359.514Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.564 363.32L757.156 350.25L767.289 359.725L740.093 373.873L731.564 363.32Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.545 396.965L606.188 370.169L638.521 386.867L586.884 413.663L554.545 396.965Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.263 370.862L579.861 383.933V410.068L554.263 396.997V370.862Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.263 370.862L579.861 383.933V384.176L554.263 371.176V370.862Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.516 362.151L579.861 383.933V410.068L622.516 388.286V362.151Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.263 370.862L579.861 383.933L622.516 362.151L596.924 349.08L554.263 370.862Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M613.988 357.797L571.339 379.579L562.798 375.221L605.453 353.439L613.988 357.797Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M571.339 379.579L571.326 388.286L562.798 383.933V375.221L571.339 379.579Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.653 391.275C594.39 390.002 592.731 389.764 590.722 390.787C590.484 390.91 590.253 391.044 590.031 391.188C589.847 391.302 589.675 391.426 589.504 391.556C588.936 391.982 588.426 392.465 587.986 392.996C587.404 393.665 587.004 394.443 586.816 395.27L590.582 393.354V397.62C590.572 397.76 590.526 397.897 590.446 398.018C590.367 398.139 590.256 398.242 590.122 398.319C589.871 398.449 589.663 398.319 589.663 398.086V397.94C589.663 397.848 589.59 397.81 589.504 397.853C589.456 397.88 589.416 397.917 589.388 397.96C589.359 398.003 589.342 398.052 589.339 398.102V398.254C589.339 398.692 589.694 398.871 590.122 398.654C590.351 398.523 590.541 398.346 590.678 398.137C590.814 397.928 590.892 397.693 590.906 397.452V393.186L594.653 391.275Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.725 397.268L585.433 402.526V392.016L595.725 386.759V397.268ZM585.831 401.914L595.327 397.041V387.349L585.831 392.222V401.914Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.904 391.561L596.612 396.813V386.304L606.904 381.052V391.561ZM597.01 396.202L606.506 391.329V381.637L597.01 386.483V396.202Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.665 384.236V386.883C603.636 387.356 603.481 387.815 603.214 388.225C602.947 388.635 602.576 388.984 602.129 389.244L601.48 389.569C600.635 390.002 599.943 389.65 599.943 388.784V386.136L601.829 385.173L601.412 386.158L602.214 385.752L601.124 388.686L602.912 385.108L602.098 385.524L602.52 384.821L603.665 384.236Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.092 392.13L601.522 392.417V389.098L602.092 388.806V392.13Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.81 392.005L599.851 393.635L603.665 391.686L601.81 392.005Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.98 385.903L607.688 391.161V380.651L617.98 375.394V385.903ZM608.086 390.549L617.582 385.676V375.979L608.086 380.852V390.549Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.988 384.886L608.68 389.125L612.794 379.574L616.988 384.886ZM609.494 388.226L616.167 384.821L612.8 380.549L609.494 388.226Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.476 385.692C612.482 385.583 612.518 385.477 612.581 385.382C612.644 385.288 612.732 385.208 612.837 385.151C613.051 385.037 613.192 385.151 613.192 385.351C613.186 385.46 613.151 385.566 613.089 385.66C613.028 385.755 612.941 385.834 612.837 385.893C612.641 386.001 612.476 385.909 612.476 385.692ZM612.629 384.729L612.543 381.805L613.125 381.507L613.039 384.523L612.629 384.729Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.232 470.167L551.875 443.372L584.208 460.069L532.571 486.865L500.232 470.167Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M499.785 443.821L525.383 456.886V483.026L499.785 469.956V443.821Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.785 443.821L525.383 456.886V457.129L499.785 444.13V443.821Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.039 435.104L525.383 456.886V483.026L568.039 461.244V435.104Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.785 443.821L525.383 456.886L568.039 435.104L542.447 422.039L499.785 443.821Z",
    fill: "#BA905E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.447 448.174L568.039 435.104L542.447 422.039V448.174Z",
    fill: "#855C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.785 443.821L490.999 434.015L533.912 412.591L542.447 422.039L499.785 443.821Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.447 422.039L553.222 414.34L578.594 427.556L568.039 435.104L542.447 422.039Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.934 442.987L499.785 443.821L525.383 456.886L512.642 455.857L486.934 442.987Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.383 456.886L568.039 435.109L580.688 434.828L536.428 457.693L525.383 456.886Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.53 471.239L528.757 477.249V465.24L540.53 459.23V471.239ZM529.216 476.551L540.077 471.006V459.912L529.216 465.457V476.551Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.826 462.852V465.89C536.793 466.432 536.617 466.959 536.31 467.43C536.004 467.9 535.576 468.3 535.063 468.597L534.328 468.971C533.361 469.469 532.565 469.063 532.565 468.072V465.04L534.72 463.957L534.248 465.083L535.167 464.617L533.942 467.974L535.993 463.881L535.057 464.358L535.54 463.551L536.826 462.852Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.026 471.884L534.377 472.219V468.418L535.026 468.088V471.884Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.702 471.743L532.467 473.611L536.826 471.38L534.702 471.743Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.204 464.764L541.43 470.779V458.743L553.204 452.733V464.764ZM541.889 470.081L552.751 464.531V453.442L541.889 458.987V470.081Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.071 463.616L542.563 468.489L547.271 457.557L552.071 463.616ZM543.5 467.438L551.14 463.54L547.283 458.667L543.5 467.438Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.91 464.52C546.912 464.391 546.951 464.264 547.022 464.152C547.094 464.039 547.197 463.944 547.32 463.876C547.565 463.746 547.73 463.876 547.73 464.103C547.728 464.233 547.689 464.36 547.617 464.473C547.546 464.587 547.444 464.683 547.32 464.753C547.075 464.877 546.91 464.769 546.91 464.52ZM547.081 463.437L546.983 460.091L547.651 459.75L547.553 463.199L547.081 463.437Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.914 458.277L554.134 464.293V452.246L565.914 446.23V458.277ZM554.593 463.594L565.455 458.044V446.956L554.593 452.5V463.594Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.839 457.855L556.216 461.748V460.605L563.839 456.712V457.855Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.7 456.545L561.812 456.994V451.163L562.7 450.713V456.545Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.477 451.179L561.034 452.424L562.363 449.555L563.477 451.179Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.445 458.716L557.563 459.165V453.334L558.445 452.885V458.716Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.222 453.35L556.785 454.596L558.114 451.721L559.222 453.35Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.668 254.286L510.512 221.301L609.555 271.769L544.718 304.758L445.668 254.286Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M472.038 247.534L459.468 241.113V234.41L472.038 240.831V247.534Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.691 289.734L542.116 283.312V276.609L554.691 283.031V289.734Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.365 268.634L500.789 262.212V255.509L513.365 261.931V268.634Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.887 237.398L479.318 230.977V224.279L491.887 230.695V237.398Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 279.598L561.965 273.176V266.479L574.541 272.895V279.598Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.214 258.498L520.638 252.077V245.379L533.214 251.795V258.498Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 272.895V279.598L582.433 275.57V268.867L574.541 272.895Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.692 283.03V289.733L562.583 285.7V279.002L554.692 283.03Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 293.166V299.869L542.734 295.836V289.138L534.842 293.166Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.214 251.795V258.498L541.106 254.47V247.767L533.214 251.795Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.365 261.931V268.634L521.257 264.6V257.902L513.365 261.931Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.516 272.066V278.769L501.408 274.736V268.038L493.516 272.066Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.893 230.695L491.887 237.398L499.785 233.37V226.667L491.893 230.695Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.044 240.831L472.038 247.534L479.93 243.5V236.803L472.044 240.831Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.189 250.967V257.664L460.081 253.636V246.938L452.189 250.967Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.613 244.545L534.842 293.166V291.152L439.613 242.531V244.545Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.864 239.824L544.087 288.445V286.431L448.864 237.81V239.824Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.166 237.073L549.389 285.689V283.675L454.166 235.054V237.073Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.468 234.41L554.691 283.031V281.016L459.468 232.395V234.41Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.713 229.688L563.936 278.309V276.295L468.713 227.674V229.688Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.015 226.938L569.238 275.559V273.539L474.015 224.924V226.938Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.318 224.285L574.541 272.906V270.886L479.318 222.271V224.285Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 270.881L479.318 222.26L487.21 218.231L582.433 266.852L574.541 270.881Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.691 281.016L459.468 232.395L467.36 228.367L562.583 276.988L554.691 281.016Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.238 273.588L474.015 224.967L477.958 222.953L573.188 271.574L569.238 273.588Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.943 276.295L468.713 227.674L472.656 225.66L567.885 274.281L563.943 276.295Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 291.152L439.613 242.531L447.505 238.503L542.734 287.124L534.842 291.152Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.389 283.724L454.166 235.103L458.109 233.088L553.338 281.709L549.389 283.724Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.087 286.431L448.864 237.81L452.807 235.796L548.036 284.417L544.087 286.431Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 270.881V272.895L582.433 268.867V266.852L574.541 270.881Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.692 281.016V283.03L562.583 279.002V276.988L554.692 281.016Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.239 273.588V275.602L573.188 273.588V271.574L569.239 273.588Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.943 276.295V278.309L567.886 276.295V274.281L563.943 276.295Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 291.152V293.166L542.734 289.138V287.124L534.842 291.152Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.389 283.724V285.738L553.338 283.724V281.709L549.389 283.724Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.087 286.431V288.445L548.036 286.431V284.417L544.087 286.431Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.189 257.664L439.613 251.248V244.545L452.189 250.967V257.664Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 299.869L522.267 293.448V286.745L534.842 293.166V299.869Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.516 278.769L480.94 272.348V265.645L493.516 272.066V278.769Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.038 238.546L459.468 232.125V225.422L472.038 231.843V238.546Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.691 280.746L542.116 274.324V267.621L554.691 274.043V280.746Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.365 259.646L500.789 253.224V246.521L513.365 252.943V259.646Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.887 228.41L479.318 221.989V215.291L491.887 221.713V228.41Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 270.61L561.965 264.189V257.491L574.541 263.912V270.61Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.214 249.51L520.638 243.089V236.391L533.214 242.807V249.51Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 263.912V270.61L582.433 266.582V259.879L574.541 263.912Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.692 274.043V280.746L562.583 276.712V270.014L554.692 274.043Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 284.178V290.881L542.734 286.848V280.15L534.842 284.178Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.214 242.807V249.51L541.106 245.482V238.779L533.214 242.807Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.365 252.943V259.646L521.257 255.612V248.915L513.365 252.943Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.516 263.079V269.776L501.408 265.748V259.05L493.516 263.079Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.893 221.713L491.887 228.41L499.785 224.382V217.679L491.893 221.713Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.044 231.843L472.038 238.546L479.93 234.512V227.815L472.044 231.843Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.189 241.979V248.682L460.081 244.648V237.951L452.189 241.979Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.613 235.557L534.842 284.178V282.164L439.613 233.543V235.557Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.864 230.836L544.087 279.457V277.443L448.864 228.822V230.836Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.166 228.085L549.389 276.701V274.687L454.166 226.066V228.085Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.468 225.427L554.691 274.043V272.028L459.468 223.407V225.427Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.713 220.7L563.936 269.321V267.307L468.713 218.686V220.7Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.015 217.95L569.238 266.571V264.557L474.015 215.936V217.95Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.318 215.297L574.541 263.918V261.898L479.318 213.283V215.297Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 261.893L479.318 213.272L487.21 209.244L582.433 257.865L574.541 261.893Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.691 272.029L459.468 223.408L467.36 219.379L562.583 268L554.691 272.029Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.238 264.6L474.015 215.979L477.958 213.965L573.188 262.586L569.238 264.6Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.943 267.307L468.713 218.686L472.656 216.672L567.885 265.293L563.943 267.307Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 282.164L439.613 233.543L447.505 229.515L542.734 278.136L534.842 282.164Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.389 274.736L454.166 226.115L458.109 224.101L553.338 272.722L549.389 274.736Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.087 277.443L448.864 228.822L452.807 226.808L548.036 275.429L544.087 277.443Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 261.893V263.912L582.433 259.879V257.865L574.541 261.893Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.692 272.029V274.043L562.583 270.014V268L554.692 272.029Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.239 264.6V266.614L573.188 264.6V262.586L569.239 264.6Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.943 267.307V269.321L567.886 267.307V265.293L563.943 267.307Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 282.164V284.178L542.734 280.15V278.136L534.842 282.164Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.389 274.736V276.75L553.338 274.736V272.722L549.389 274.736Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.087 277.443V279.457L548.036 277.443V275.429L544.087 277.443Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.189 248.682L439.613 242.26V235.557L452.189 241.979V248.682Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 290.881L522.267 284.46V277.757L534.842 284.178V290.881Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.516 269.776L480.94 263.36V256.657L493.516 263.079V269.776Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.038 229.591L459.468 223.175V216.472L472.038 222.893V229.591Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.691 271.79L542.116 265.374V258.671L554.691 265.093V271.79Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.365 250.69L500.789 244.269V237.571L513.365 243.993V250.69Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.887 219.455L479.318 213.039V206.336L491.887 212.758V219.455Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 261.655L561.965 255.239V248.536L574.541 254.957V261.655Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.214 240.56L520.638 234.139V227.436L533.214 233.857V240.56Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 254.957V261.655L582.433 257.626V250.929L574.541 254.957Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.692 265.093V271.79L562.583 267.762V261.064L554.692 265.093Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 275.228V281.926L542.734 277.898V271.195L534.842 275.228Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.214 233.857V240.56L541.106 236.527V229.829L533.214 233.857Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.365 243.993V250.691L521.257 246.662V239.965L513.365 243.993Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.516 254.129V260.826L501.408 256.798V250.1L493.516 254.129Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.893 212.757L491.887 219.455L499.785 215.427V208.729L491.893 212.757Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.044 222.893L472.038 229.591L479.93 225.562V218.865L472.044 222.893Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.189 233.029V239.726L460.081 235.698V228.995L452.189 233.029Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.613 226.607L534.842 275.228V273.214L439.613 224.593V226.607Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.864 221.886L544.087 270.507V268.488L448.864 219.872V221.886Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.166 219.13L549.389 267.751V265.737L454.166 217.116V219.13Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.468 216.472L554.691 265.093V263.079L459.468 214.458V216.472Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.713 211.75L563.936 260.371V258.357L468.713 209.736V211.75Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.015 208.994L569.238 257.615V255.601L474.015 206.98V208.994Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.318 206.341L574.541 254.962V252.948L479.318 204.327V206.341Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 252.943L479.318 204.322L487.21 200.294L582.433 248.915L574.541 252.943Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.691 263.078L459.468 214.457L467.36 210.429L562.583 259.045L554.691 263.078Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.238 255.65L474.015 207.029L477.958 205.015L573.188 253.636L569.238 255.65Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.943 258.357L468.713 209.736L472.656 207.722L567.885 256.343L563.943 258.357Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 273.214L439.613 224.593L447.505 220.565L542.734 269.181L534.842 273.214Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.389 265.786L454.166 217.165L458.109 215.151L553.338 263.772L549.389 265.786Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.087 268.493L448.864 219.872L452.807 217.858L548.036 266.479L544.087 268.493Z",
    fill: "#B3874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 252.943V254.957L582.433 250.929V248.915L574.541 252.943Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.692 263.079V265.093L562.583 261.064V259.05L554.692 263.079Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.239 255.65V257.664L573.188 255.65V253.636L569.239 255.65Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.943 258.357V260.371L567.886 258.357V256.343L563.943 258.357Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 273.214V275.228L542.734 271.195V269.181L534.842 273.214Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.389 265.786V267.8L553.338 265.786V263.772L549.389 265.786Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.087 268.493V270.507L548.036 268.493V266.479L544.087 268.493Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.189 239.726L439.613 233.305V226.607L452.189 233.029V239.726Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 281.926L522.267 275.505V268.807L534.842 275.228V281.926Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.516 260.826L480.94 254.405V247.707L493.516 254.129V260.826Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.038 220.646L459.468 214.23V207.527L472.038 213.949V220.646Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.691 262.846L542.116 256.43V249.727L554.691 256.148V262.846Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.365 241.751L500.789 235.33V228.627L513.365 235.048V241.751Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.887 210.516L479.318 204.094V197.391L491.887 203.813V210.516Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 252.715L561.965 246.294V239.591L574.541 246.012V252.715Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.214 231.616L520.638 225.194V218.491L533.214 224.913V231.616Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 246.012V252.715L582.433 248.682V241.984L574.541 246.012Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.692 256.148V262.846L562.583 258.817V252.12L554.692 256.148Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 266.284V272.981L542.734 268.953V262.256L534.842 266.284Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.214 224.913V231.616L541.106 227.582V220.884L533.214 224.913Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.365 235.048V241.746L521.257 237.718V231.02L513.365 235.048Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.516 245.184V251.882L501.408 247.853V241.156L493.516 245.184Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.893 203.813L491.887 210.516L499.785 206.482V199.785L491.893 203.813Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.044 213.949L472.038 220.646L479.93 216.618V209.92L472.044 213.949Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.189 224.084V230.782L460.081 226.754V220.056L452.189 224.084Z",
    fill: "#A87F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.613 217.663L534.842 266.284V264.27L439.613 215.649V217.663Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.864 212.942L544.087 261.562V259.548L448.864 210.927V212.942Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.166 210.186L549.389 258.807V256.792L454.166 208.172V210.186Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.468 207.527L554.691 256.148V254.134L459.468 205.513V207.527Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.713 202.806L563.936 251.427V249.413L468.713 200.792V202.806Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.015 200.055L569.238 248.676V246.657L474.015 198.036V200.055Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.318 197.402L574.541 246.018V244.004L479.318 195.383V197.402Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 243.998L479.318 195.377L487.21 191.349L582.433 239.97L574.541 243.998Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.691 254.134L459.468 205.513L467.36 201.485L562.583 250.106L554.691 254.134Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.238 246.705L474.015 198.084L477.958 196.07L573.188 244.691L569.238 246.705Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.943 249.413L468.713 200.792L472.656 198.778L567.885 247.399L563.943 249.413Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 264.27L439.613 215.649L447.505 211.62L542.734 260.236L534.842 264.27Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.389 256.841L454.166 208.22L458.109 206.206L553.338 254.827L549.389 256.841Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.087 259.548L448.864 210.927L452.807 208.913L548.036 257.534L544.087 259.548Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.541 243.998V246.012L582.433 241.984V239.97L574.541 243.998Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.692 254.134V256.148L562.583 252.12V250.106L554.692 254.134Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.239 246.706V248.72L573.188 246.706V244.691L569.239 246.706Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.943 249.413V251.427L567.886 249.413V247.399L563.943 249.413Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 264.27V266.284L542.734 262.256V260.236L534.842 264.27Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.389 256.841V258.855L553.338 256.841V254.827L549.389 256.841Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.087 259.548V261.563L548.036 259.548V257.534L544.087 259.548Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.189 230.782L439.613 224.36V217.663L452.189 224.084V230.782Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.842 272.981L522.267 266.56V259.862L534.842 266.284V272.981Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.516 251.882L480.94 245.46V238.763L493.516 245.184V251.882Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.253 273.463L700.364 243.354L783.544 285.851L726.434 315.961L643.253 273.463Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 302.685L727.536 296.263V289.56L740.111 295.982V302.685Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.784 281.585L686.209 275.163V268.46L698.784 274.882V281.585Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 292.549L747.385 286.127V279.43L759.96 285.851V292.549Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.633 271.449L706.058 265.028V258.33L718.633 264.752V271.449Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 285.851V292.549L767.852 288.521V281.818L759.96 285.851Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 295.982V302.685L748.003 298.651V291.953L740.111 295.982Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.262 306.117V312.815L728.154 308.787V302.089L720.262 306.117Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.77 267.383V274.086L731.668 270.052V263.355L723.77 267.383Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.921 277.519V284.216L711.813 280.188L711.819 273.49L703.921 277.519Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.072 287.654V294.352L691.964 290.324V283.626L684.072 287.654Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.676 252.531V259.234L702.568 255.201V248.503L694.676 252.531Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.827 262.667V269.365L682.719 265.336V258.639L674.827 262.667Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.978 272.803V279.5L662.87 275.472V268.774L654.978 272.803Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.086 268.78L720.262 306.117V304.103L647.086 266.766V268.78Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.331 264.059L729.507 301.396V299.382L656.331 262.044V264.059Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.633 261.308L734.809 298.64V296.626L661.633 259.289V261.308Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.935 258.644L740.111 295.982V293.968L666.935 256.63V258.644Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.18 253.923L749.356 291.26V289.246L676.18 251.909V253.923Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.482 251.172L754.658 288.51V286.49L681.482 249.158V251.172Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.784 248.519L759.96 285.857V283.843L686.784 246.505V248.519Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 283.832L686.784 246.494L694.676 242.466L767.852 279.804L759.96 283.832Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 293.968L666.935 256.63L674.827 252.602L748.003 289.939L740.111 293.968Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.658 286.539L681.482 249.202L685.431 247.187L758.607 284.525L754.658 286.539Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.356 289.246L676.18 251.909L680.129 249.895L753.305 287.232L749.356 289.246Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.262 304.103L647.086 266.766L654.978 262.737L728.154 300.075L720.262 304.103Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.809 296.675L661.633 259.337L665.576 257.323L738.752 294.661L734.809 296.675Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.507 299.382L656.331 262.044L660.28 260.03L733.456 297.368L729.507 299.382Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 283.832V285.851L767.852 281.818V279.804L759.96 283.832Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 293.967V295.982L748.003 291.953V289.939L740.111 293.967Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.658 286.539V288.553L758.607 286.539V284.525L754.658 286.539Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.356 289.246V291.26L753.305 289.246V287.232L749.356 289.246Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.262 304.103V306.117L728.154 302.089V300.075L720.262 304.103Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.809 296.675V298.689L738.752 296.675V294.661L734.809 296.675Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.507 299.382V301.396L733.456 299.382V297.368L729.507 299.382Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.978 272.803V279.5L647.086 275.472V268.774L654.978 272.803Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.256 306.117L720.262 312.815L712.37 308.787L712.364 302.089L720.256 306.117Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.072 287.654V294.352L676.18 290.324V283.626L684.072 287.654Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 293.724L727.536 287.302V280.605L740.111 287.021V293.724Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.784 272.624L686.209 266.203V259.505L698.784 265.921V272.624Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 283.588L747.385 277.167V270.469L759.96 276.891V283.588Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.633 262.488L706.058 256.067V249.369L718.633 255.791V262.488Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 276.891V283.588L767.852 279.56V272.857L759.96 276.891Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 287.026V293.724L748.003 289.696V282.993L740.111 287.026Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.262 297.157V303.86L728.154 299.826V293.128L720.262 297.157Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.77 258.422V265.125L731.668 261.091V254.394L723.77 258.422Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.921 268.558V275.255L711.813 271.227L711.819 264.53L703.921 268.558Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.072 278.694V285.391L691.964 281.363V274.665L684.072 278.694Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.676 243.571V250.274L702.568 246.245V239.542L694.676 243.571Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.827 253.706V260.409L682.719 256.376V249.678L674.827 253.706Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.978 263.842V270.54L662.87 266.511V259.814L654.978 263.842Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.086 259.819L720.262 297.157V295.142L647.086 257.805V259.819Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.331 255.098L729.507 292.435V290.421L656.331 253.084V255.098Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.633 252.347L734.809 289.685V287.665L661.633 250.333V252.347Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.935 249.689L740.111 287.026V285.007L666.935 247.669V249.689Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.18 244.968L749.356 282.3V280.285L676.18 242.948V244.968Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.482 242.212L754.658 279.549V277.535L681.482 240.197V242.212Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.784 239.559L759.96 276.896V274.882L686.784 237.544V239.559Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 274.876L686.784 237.534L694.676 233.505L767.852 270.843L759.96 274.876Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 285.007L666.935 247.669L674.827 243.641L748.003 280.979L740.111 285.007Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.658 277.578L681.482 240.241L685.431 238.227L758.607 275.564L754.658 277.578Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.356 280.285L676.18 242.948L680.129 240.934L753.305 278.271L749.356 280.285Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.262 295.142L647.086 257.805L654.978 253.777L728.154 291.114L720.262 295.142Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.809 287.714L661.633 250.376L665.576 248.362L738.752 285.7L734.809 287.714Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.507 290.421L656.331 253.084L660.28 251.069L733.456 288.407L729.507 290.421Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 274.876V276.891L767.852 272.857V270.843L759.96 274.876Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 285.007V287.026L748.003 282.993V280.978L740.111 285.007Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.658 277.578V279.592L758.607 277.578V275.564L754.658 277.578Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.356 280.285V282.3L753.305 280.285V278.271L749.356 280.285Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.262 295.142V297.157L728.154 293.128V291.114L720.262 295.142Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.809 287.714V289.728L738.752 287.714V285.7L734.809 287.714Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.507 290.421V292.435L733.456 290.421V288.407L729.507 290.421Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.978 263.842V270.54L647.086 266.511V259.814L654.978 263.842Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.256 297.157L720.262 303.86L712.37 299.826L712.364 293.128L720.256 297.157Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.072 278.694V285.391L676.18 281.363V274.665L684.072 278.694Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 284.806L727.536 278.385V271.687L740.111 278.103V284.806Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.784 263.707L686.209 257.285V250.588L698.784 257.009V263.707Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 274.671L747.385 268.249V261.552L759.96 267.973V274.671Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.633 253.571L706.058 247.15V240.452L718.633 246.873V253.571Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 267.973V274.671L767.852 270.642V263.939L759.96 267.973Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 278.103V284.806L748.003 280.778V274.075L740.111 278.103Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.262 288.239V294.942L728.154 290.908V284.211L720.262 288.239Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.77 249.505V256.208L731.668 252.174V245.476L723.77 249.505Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.921 259.64V266.343L711.813 262.31L711.819 255.612L703.921 259.64Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.072 269.776V276.474L691.964 272.445V265.748L684.072 269.776Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.676 234.653V241.356L702.568 237.322V230.625L694.676 234.653Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.827 244.789V251.492L682.719 247.458V240.761L674.827 244.789Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.978 254.925V261.622L662.87 257.594V250.896L654.978 254.925Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.086 250.902L720.262 288.239V286.225L647.086 248.888V250.902Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.331 246.18L729.507 283.518V281.504L656.331 244.166V246.18Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.633 243.43L734.809 280.767V278.748L661.633 241.416V243.43Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.935 240.771L740.111 278.109V276.089L666.935 238.752V240.771Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.18 236.045L749.356 273.388V271.368L676.18 234.031V236.045Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.482 233.294L754.658 270.632V268.617L681.482 231.28V233.294Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.784 230.641L759.96 267.979V265.964L686.784 228.627V230.641Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 265.954L686.784 228.622L694.676 224.588L767.852 261.925L759.96 265.954Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 276.089L666.935 238.752L674.827 234.724L748.003 272.061L740.111 276.089Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.658 268.661L681.482 231.323L685.431 229.309L758.607 266.647L754.658 268.661Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.356 271.368L676.18 234.031L680.129 232.016L753.305 269.354L749.356 271.368Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.262 286.225L647.086 248.887L654.978 244.859L728.154 282.197L720.262 286.225Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.809 278.796L661.633 241.459L665.576 239.445L738.752 276.782L734.809 278.796Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.507 281.504L656.331 244.166L660.28 242.152L733.456 279.49L729.507 281.504Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 265.954V267.973L767.852 263.939V261.925L759.96 265.954Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 276.089V278.103L748.003 274.075V272.061L740.111 276.089Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.658 268.661V270.68L758.607 268.661V266.647L754.658 268.661Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.356 271.368V273.387L753.305 271.368V269.354L749.356 271.368Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.262 286.225V288.239L728.154 284.211V282.197L720.262 286.225Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.809 278.796V280.811L738.752 278.796V276.782L734.809 278.796Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.507 281.504V283.518L733.456 281.504V279.49L729.507 281.504Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.978 254.925V261.622L647.086 257.594V250.896L654.978 254.925Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.256 288.239L720.262 294.942L712.37 290.908L712.364 284.211L720.256 288.239Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.072 269.776V276.474L676.18 272.445V265.748L684.072 269.776Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 275.932L727.536 269.516V262.813L740.111 269.235V275.932Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.784 254.838L686.209 248.416V241.713L698.784 248.135V254.838Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 265.802L747.385 259.381V252.678L759.96 259.099V265.802Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.633 244.702L706.058 238.281V231.578L718.633 237.999V244.702Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 259.099V265.802L767.852 261.768V255.071L759.96 259.099Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 269.235V275.932L748.003 271.904V265.206L740.111 269.235Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.262 279.37V286.068L728.154 282.04V275.342L720.262 279.37Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.77 240.636V247.334L731.668 243.305V236.608L723.77 240.636Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.921 250.772V257.469L711.813 253.441L711.819 246.738L703.921 250.772Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.072 260.907V267.605L691.964 263.577V256.874L684.072 260.907Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.676 225.784V232.482L702.568 228.454V221.756L694.676 225.784Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.827 235.92V242.618L682.719 238.589V231.892L674.827 235.92Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.978 246.056V252.753L662.87 248.725V242.022L654.978 246.056Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.086 242.033L720.262 279.37V277.356L647.086 240.019V242.033Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.331 237.312L729.507 274.649V272.635L656.331 235.297V237.312Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.633 234.556L734.809 271.893V269.879L661.633 232.542V234.556Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.935 231.897L740.111 269.235V267.221L666.935 229.883V231.897Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.18 227.176L749.356 264.513V262.499L676.18 225.162V227.176Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.482 224.425L754.658 261.757V259.743L681.482 222.406V224.425Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.784 221.772L759.96 259.104V257.09L686.784 219.753V221.772Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 257.085L686.784 219.747L694.676 215.719L767.852 253.057L759.96 257.085Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 267.221L666.935 229.883L674.827 225.855L748.003 263.192L740.111 267.221Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.658 259.792L681.482 222.455L685.431 220.44L758.607 257.778L754.658 259.792Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.356 262.499L676.18 225.162L680.129 223.148L753.305 260.485L749.356 262.499Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.262 277.356L647.086 240.019L654.978 235.99L728.154 273.323L720.262 277.356Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.809 269.928L661.633 232.59L665.576 230.576L738.752 267.914L734.809 269.928Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.507 272.635L656.331 235.297L660.28 233.283L733.456 270.621L729.507 272.635Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.96 257.085V259.099L767.852 255.071V253.057L759.96 257.085Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.111 267.221V269.235L748.003 265.206V263.192L740.111 267.221Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.658 259.792V261.806L758.607 259.792V257.778L754.658 259.792Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.356 262.499V264.513L753.305 262.499V260.485L749.356 262.499Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.262 277.356V279.37L728.154 275.342V273.323L720.262 277.356Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.809 269.928V271.942L738.752 269.928V267.914L734.809 269.928Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.507 272.635V274.649L733.456 272.635V270.621L729.507 272.635Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.978 246.056V252.753L647.086 248.725V242.022L654.978 246.056Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.256 279.37L720.262 286.068L712.37 282.04L712.364 275.342L720.256 279.37Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.072 260.907V267.605L676.18 263.577V256.874L684.072 260.907Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.515 376.948L736.781 346.075L814.793 385.86L755.528 416.733L677.515 376.948Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 402.585L754.909 396.169V389.466L767.485 395.887V402.585Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.158 381.485L713.582 375.069V368.366L726.158 374.788V381.485Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 392.455L774.758 386.033V379.33L787.334 385.752V392.455Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.007 371.355L733.432 364.934V358.231L746.007 364.652V371.355Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 385.752V392.455L795.226 388.421V381.724L787.334 385.752Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 395.888V402.585L775.377 398.557V391.859L767.485 395.888Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 406.023V412.721L755.528 408.693V401.995L747.636 406.023Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.15 367.289L751.144 373.986L759.042 369.958V363.261L751.15 367.289Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.295 377.425V384.122L739.187 380.094V373.391L731.295 377.425Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.446 387.555V394.258L719.337 390.23V383.527L711.446 387.555Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.05 352.437V359.135L729.942 355.107V348.409L722.05 352.437Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.201 362.573V369.271L710.093 365.242V358.545L702.201 362.573Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.352 372.709V379.406L690.243 375.378V368.675L682.352 372.709Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.46 368.686L747.636 406.023V404.009L674.46 366.672V368.686Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.705 363.964L756.881 401.302V399.288L683.705 361.95V363.964Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.007 361.208L762.183 398.546V396.532L689.007 359.194V361.208Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.309 358.55L767.485 395.888V393.873L694.309 356.536V358.55Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.554 353.829L776.73 391.166V389.152L703.554 351.815V353.829Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.856 351.073L782.032 388.41V386.396L708.856 349.059V351.073Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.158 348.42L787.334 385.757V383.743L714.158 346.406V348.42Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 383.738L714.158 346.4L722.05 342.372L795.226 379.709L787.334 383.738Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 393.873L694.309 356.536L702.201 352.508L775.377 389.845L767.485 393.873Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.032 386.445L708.856 349.107L712.799 347.093L785.981 384.431L782.032 386.445Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.73 389.152L703.554 351.815L707.503 349.8L780.679 387.138L776.73 389.152Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 404.009L674.46 366.672L682.352 362.638L755.528 399.975L747.636 404.009Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.183 396.581L689.007 359.243L692.95 357.229L766.126 394.566L762.183 396.581Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.881 399.288L683.705 361.95L687.648 359.936L760.83 397.274L756.881 399.288Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 383.738V385.752L795.226 381.724V379.709L787.334 383.738Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 393.873V395.888L775.377 391.859V389.845L767.485 393.873Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.032 386.445V388.459L785.981 386.445V384.431L782.032 386.445Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.73 389.152V391.166L780.679 389.152V387.138L776.73 389.152Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 404.009V406.023L755.528 401.995V399.975L747.636 404.009Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.183 396.581V398.595L766.125 396.581V394.566L762.183 396.581Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.881 399.288V401.302L760.83 399.288V397.274L756.881 399.288Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.352 372.709V379.406L674.46 375.378V368.675L682.352 372.709Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 406.023V412.721L739.738 408.693V401.995L747.636 406.023Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.446 387.555V394.258L703.554 390.23V383.527L711.446 387.555Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 393.624L754.909 387.208V380.505L767.485 386.927V393.624Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.158 372.525L713.582 366.109V359.406L726.158 365.827V372.525Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 383.494L774.758 377.073V370.37L787.334 376.791V383.494Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.007 362.394L733.432 355.973V349.27L746.007 355.691V362.394Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 376.791V383.494L795.226 379.46V372.763L787.334 376.791Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 386.927V393.624L775.377 389.596V382.898L767.485 386.927Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 397.062V403.76L755.528 399.732V393.034L747.636 397.062Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.15 358.328L751.144 365.026L759.042 360.997V354.3L751.15 358.328Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.295 368.464V375.161L739.187 371.133V364.435L731.295 368.464Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.446 378.6V385.297L719.337 381.269V374.566L711.446 378.6Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.05 343.476V350.174L729.942 346.146V339.448L722.05 343.476Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.201 353.612V360.31L710.093 356.281V349.584L702.201 353.612Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.352 363.748V370.445L690.243 366.417V359.714L682.352 363.748Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.46 359.725L747.636 397.062V395.048L674.46 357.711V359.725Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.705 355.004L756.881 392.341V390.327L683.705 352.99V355.004Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.007 352.248L762.183 389.585V387.571L689.007 350.234V352.248Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.309 349.589L767.485 386.927V384.913L694.309 347.575V349.589Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.554 344.868L776.73 382.205V380.191L703.554 342.854V344.868Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.856 342.117L782.032 379.455V377.435L708.856 340.098V342.117Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.158 339.464L787.334 376.796V374.782L714.158 337.445V339.464Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 374.777L714.158 337.439L722.05 333.411L795.226 370.749L787.334 374.777Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 384.913L694.309 347.575L702.201 343.547L775.377 380.884L767.485 384.913Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.032 377.484L708.856 340.147L712.799 338.132L785.981 375.47L782.032 377.484Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.73 380.191L703.554 342.854L707.503 340.84L780.679 378.177L776.73 380.191Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 395.048L674.46 357.711L682.352 353.682L755.528 391.02L747.636 395.048Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.183 387.62L689.007 350.282L692.95 348.268L766.126 385.606L762.183 387.62Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.881 390.327L683.705 352.99L687.648 350.975L760.83 388.313L756.881 390.327Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 374.777V376.791L795.226 372.763V370.749L787.334 374.777Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 384.913V386.927L775.377 382.898V380.884L767.485 384.913Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.032 377.484V379.498L785.981 377.484V375.47L782.032 377.484Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.73 380.191V382.205L780.679 380.191V378.177L776.73 380.191Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 395.048V397.062L755.528 393.034V391.02L747.636 395.048Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.183 387.62V389.634L766.125 387.62V385.606L762.183 387.62Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.881 390.327V392.341L760.83 390.327V388.313L756.881 390.327Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.352 363.748V370.445L674.46 366.417V359.714L682.352 363.748Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 397.062V403.76L739.738 399.732V393.034L747.636 397.062Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.446 378.6V385.297L703.554 381.269V374.566L711.446 378.6Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 384.707L754.909 378.291V371.588L767.485 378.009V384.707Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.158 363.612L713.582 357.191V350.488L726.158 356.909V363.612Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 374.577L774.758 368.155V361.458L787.334 367.874V374.577Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.007 353.477L733.432 347.055V340.358L746.007 346.774V353.477Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 367.874V374.577L795.226 370.548V363.845L787.334 367.874Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 378.009V384.707L775.377 380.679V373.981L767.485 378.009Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 388.145V394.843L755.528 390.814V384.117L747.636 388.145Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.15 349.411L751.144 356.108L759.042 352.08V345.382L751.15 349.411Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.295 359.546V366.244L739.187 362.216V355.518L731.295 359.546Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.446 369.682V376.38L719.337 372.351V365.648L711.446 369.682Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.05 334.559V341.257L729.942 337.228V330.531L722.05 334.559Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.201 344.695V351.392L710.093 347.364V340.666L702.201 344.695Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.352 354.83V361.528L690.243 357.5V350.797L682.352 354.83Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.46 350.808L747.636 388.145V386.131L674.46 348.793V350.808Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.705 346.086L756.881 383.424V381.409L683.705 344.072V346.086Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.007 343.33L762.183 380.668V378.654L689.007 341.316V343.33Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.309 340.672L767.485 378.009V375.995L694.309 338.658V340.672Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.554 335.951L776.73 373.288V371.274L703.554 333.936V335.951Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.856 333.2L782.032 370.538V368.518L708.856 331.18V333.2Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.158 330.547L787.334 367.884V365.865L714.158 328.527V330.547Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 365.859L714.158 328.522L722.05 324.494L795.226 361.831L787.334 365.859Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 375.995L694.309 338.658L702.201 334.629L775.377 371.967L767.485 375.995Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.032 368.567L708.856 331.229L712.799 329.215L785.981 366.553L782.032 368.567Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.73 371.274L703.554 333.936L707.503 331.922L780.679 369.26L776.73 371.274Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 386.131L674.46 348.793L682.352 344.765L755.528 382.103L747.636 386.131Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.183 378.702L689.007 341.365L692.95 339.351L766.126 376.688L762.183 378.702Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.881 381.41L683.705 344.072L687.648 342.058L760.83 379.395L756.881 381.41Z",
    fill: "#9B6B28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 365.859V367.874L795.226 363.845V361.831L787.334 365.859Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 375.995V378.009L775.377 373.981V371.967L767.485 375.995Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.032 368.567V370.581L785.981 368.567V366.552L782.032 368.567Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.73 371.274V373.288L780.679 371.274V369.26L776.73 371.274Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 386.131V388.145L755.528 384.117V382.103L747.636 386.131Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.183 378.702V380.716L766.125 378.702V376.688L762.183 378.702Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.881 381.409V383.424L760.83 381.409V379.395L756.881 381.409Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.352 354.83V361.528L674.46 357.5V350.797L682.352 354.83Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 388.145V394.843L739.738 390.814V384.117L747.636 388.145Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.446 369.682V376.38L703.554 372.351V365.648L711.446 369.682Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 375.838L754.909 369.417V362.719L767.485 369.141V375.838Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.158 354.738L713.582 348.317V341.619L726.158 348.041V354.738Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 365.702L774.758 359.286V352.583L787.334 359.005V365.702Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.007 344.603L733.432 338.187V331.484L746.007 337.905V344.603Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 359.005V365.702L795.226 361.674V354.977L787.334 359.005Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 369.141V375.838L775.377 371.81V365.112L767.485 369.141Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 379.276V385.974L755.528 381.946V375.243L747.636 379.276Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.15 340.542L751.144 347.239L759.042 343.211V336.508L751.15 340.542Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.295 350.672V357.375L739.187 353.347V346.644L731.295 350.672Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.446 360.808V367.511L719.337 363.477V356.78L711.446 360.808Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.05 325.69V332.388L729.942 328.36V321.657L722.05 325.69Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.201 335.826V342.524L710.093 338.495V331.792L702.201 335.826Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.352 345.956V352.659L690.243 348.626V341.928L682.352 345.956Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.46 341.939L747.636 379.276V377.257L674.46 339.925V341.939Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.705 337.217L756.881 374.549V372.535L683.705 335.198V337.217Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.007 334.462L762.183 371.799V369.785L689.007 332.447V334.462Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.309 331.803L767.485 369.141V367.126L694.309 329.789V331.803Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.554 327.082L776.73 364.419V362.405L703.554 325.068V327.082Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.856 324.326L782.032 361.663V359.649L708.856 322.312V324.326Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.158 321.673L787.334 359.01V356.996L714.158 319.659V321.673Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 356.991L714.158 319.653L722.05 315.625L795.226 352.957L787.334 356.991Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 367.126L694.309 329.789L702.201 325.755L775.377 363.093L767.485 367.126Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.032 359.698L708.856 322.36L712.799 320.346L785.981 357.684L782.032 359.698Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.73 362.405L703.554 325.068L707.503 323.048L780.679 360.391L776.73 362.405Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 377.257L674.46 339.925L682.352 335.891L755.528 373.228L747.636 377.257Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.183 369.828L689.007 332.496L692.95 330.477L766.126 367.814L762.183 369.828Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.881 372.535L683.705 335.203L687.648 333.184L760.83 370.521L756.881 372.535Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.334 356.991V359.005L795.226 354.977V352.962L787.334 356.991Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.485 367.126V369.141L775.377 365.112V363.093L767.485 367.126Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.032 359.698V361.712L785.981 359.698V357.684L782.032 359.698Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.73 362.405V364.419L780.679 362.405V360.391L776.73 362.405Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 377.257V379.276L755.528 375.243V373.228L747.636 377.257Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.183 369.828V371.848L766.125 369.828V367.814L762.183 369.828Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.881 372.535V374.555L760.83 372.535V370.521L756.881 372.535Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.352 345.956V352.659L674.46 348.626V341.928L682.352 345.956Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.636 379.276V385.974L739.738 381.946V375.243L747.636 379.276Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.446 360.808V367.511L703.554 363.477V356.78L711.446 360.808Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.531 440.079L694.241 396.862L743.54 422.039L658.835 465.256L609.531 440.079Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M634.823 453.031L647.398 446.609V439.912L634.823 446.328V453.031Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.15 431.931L688.725 425.51V418.807L676.15 425.228V431.931Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.974 442.895L627.549 436.474V429.776L614.974 436.197V442.895Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.3 421.795L668.876 415.374V408.676L656.3 415.092V421.795Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.974 436.197V442.895L607.082 438.867V432.164L614.974 436.197Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.823 446.328V453.031L626.931 448.997V442.299L634.823 446.328Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.672 456.463V463.166L646.78 459.133V452.435L654.672 456.463Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.158 417.729V424.432L643.266 420.398V413.701L651.158 417.729Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.007 427.865V434.562L663.115 430.534V423.836L671.007 427.865Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.856 438L690.862 444.698L682.97 440.67L682.964 433.972L690.856 438Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.258 402.877V409.58L672.366 405.547V398.849L680.258 402.877Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.107 413.013V419.711L692.215 415.682V408.985L700.107 413.013Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.956 423.149V429.846L712.064 425.818V419.121L719.956 423.149Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.848 419.126L654.672 456.463V454.449L727.848 417.112V419.126Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.603 414.405L645.427 451.742V449.728L718.603 412.391V414.405Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.301 411.649L640.125 448.986V446.972L713.301 409.635V411.649Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.999 408.99L634.823 446.333V444.314L707.999 406.976V408.99Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.754 404.269L625.578 441.606V439.592L698.754 402.255V404.269Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.452 401.518L620.276 438.856V436.842L693.452 399.504V401.518Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.149 398.865L614.974 436.203V434.189L688.149 396.851V398.865Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.974 434.178L688.15 396.84L680.258 392.812L607.082 430.15L614.974 434.178Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.823 444.314L707.999 406.976L700.107 402.948L626.931 440.285L634.823 444.314Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.276 436.885L693.452 399.548L689.503 397.533L616.327 434.871L620.276 436.885Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.578 439.592L698.754 402.255L694.805 400.241L621.629 437.578L625.578 439.592Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.672 454.449L727.848 417.112L719.956 413.083L646.78 450.421L654.672 454.449Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.125 447.021L713.301 409.683L709.352 407.669L636.176 445.007L640.125 447.021Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.427 449.728L718.603 412.39L714.654 410.376L641.478 447.714L645.427 449.728Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.974 434.178V436.197L607.082 432.164V430.15L614.974 434.178Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.823 444.314V446.328L626.931 442.299V440.285L634.823 444.314Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.276 436.885V438.899L616.327 436.885V434.871L620.276 436.885Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.578 439.592V441.606L621.629 439.592V437.578L625.578 439.592Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.672 454.449V456.463L646.78 452.435V450.421L654.672 454.449Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.125 447.021V449.035L636.176 447.021V445.007L640.125 447.021Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.427 449.728V451.742L641.478 449.728V447.714L645.427 449.728Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.956 423.149V429.846L727.848 425.818V419.121L719.956 423.149Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.672 456.463V463.166L662.564 459.133V452.435L654.672 456.463Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.862 438V444.698L698.754 440.67V433.972L690.862 438Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.261 315.43L624.684 282.088L707.864 324.586L644.435 357.927L561.261 315.43Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M658.694 342.973L644.888 335.923V328.565L658.694 335.615V342.973Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.32 319.805L599.514 312.755V305.403L613.32 312.452V319.805Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.484 331.841L666.678 324.797V317.439L680.484 324.488V331.841Z",
    fill: "#8C5927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.117 308.678L621.31 301.629V294.271L635.117 301.32V308.678Z",
    fill: "#D3A972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.484 324.488V331.841L689.154 327.417V320.065L680.484 324.488Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.694 335.615V342.973L667.358 338.544V331.191L658.694 335.615Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.898 346.741V354.099L645.568 349.676V342.318L636.898 346.741Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.755 304.217V311.57L649.425 307.146V299.793L640.755 304.217Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.965 315.343V322.696L627.629 318.273V310.92L618.965 315.343Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.169 326.47V333.823L605.839 329.399V322.046L597.169 326.47Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.814 287.909V295.267L617.478 290.843V283.485L608.814 287.909Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.018 299.035V306.393L595.682 301.97L595.688 294.612L587.018 299.035Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.228 310.167V317.52L573.892 313.096V305.738L565.228 310.167Z",
    fill: "#805321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.559 305.749L636.898 346.741V344.532L556.559 303.54V305.749Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.716 300.568L647.055 341.56V339.345L566.716 298.353V300.568Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.532 297.541L652.872 338.533V336.324L572.532 295.332V297.541Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.355 294.623L658.694 335.615V333.406L578.355 292.414V294.623Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.506 289.441L668.845 330.433V328.219L588.506 287.227V289.441Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.328 286.415L674.668 327.407V325.198L594.328 284.205V286.415Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.145 283.502L680.484 324.494V322.285L600.145 281.292V283.502Z",
    fill: "#C0954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.484 322.274L600.145 281.282L608.814 276.858L689.154 317.85L680.484 322.274Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.694 333.4L578.355 292.408L587.018 287.985L667.358 328.977L658.694 333.4Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.668 325.246L594.328 284.254L598.657 282.045L679.002 323.037L674.668 325.246Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.845 328.219L588.506 287.227L592.841 285.012L673.18 326.01L668.845 328.219Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.898 344.532L556.559 303.54L565.228 299.111L645.568 340.103L636.898 344.532Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.872 336.373L572.532 295.381L576.867 293.172L657.207 334.164L652.872 336.373Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.055 339.345L566.716 298.353L571.045 296.144L651.384 337.136L647.055 339.345Z",
    fill: "#F1CA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.484 322.274V324.488L689.154 320.065V317.85L680.484 322.274Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.694 333.4V335.615L667.358 331.191V328.977L658.694 333.4Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.668 325.246V327.461L679.002 325.246V323.037L674.668 325.246Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.845 328.219V330.433L673.18 328.219V326.01L668.845 328.219Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.898 344.532V346.741L645.568 342.318V340.103L636.898 344.532Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.872 336.373V338.587L657.207 336.373V334.164L652.872 336.373Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.055 339.345V341.56L651.384 339.345V337.136L647.055 339.345Z",
    fill: "#E4BB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.228 310.167V317.52L556.559 313.096V305.738L565.228 310.167Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.898 346.741V354.099L628.235 349.676V342.318L636.898 346.741Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.169 326.47V333.823L588.506 329.399V322.046L597.169 326.47Z",
    fill: "#C89E6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.716 275.163L599.863 282.901V298.364L584.716 290.632V275.163Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.716 275.163L599.863 282.901V283.041L584.716 275.353V275.163Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.106 270.009L599.863 282.901V298.364L625.106 285.472V270.009Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.716 275.163L599.863 282.901L625.106 270.009L609.959 262.277L584.716 275.163Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M620.055 267.437L594.818 280.323L589.767 277.746L615.004 264.854L620.055 267.437Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M594.818 280.323L594.812 285.478L589.767 282.901V277.746L594.818 280.323Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.612 287.243C608.459 286.49 607.479 286.349 606.292 286.956C606.15 287.028 606.013 287.108 605.882 287.194C605.772 287.26 605.668 287.333 605.569 287.411C605.232 287.661 604.93 287.947 604.669 288.261C604.324 288.657 604.088 289.118 603.978 289.609L606.206 288.472V291C606.2 291.083 606.172 291.162 606.125 291.234C606.079 291.305 606.014 291.366 605.937 291.412C605.784 291.488 605.667 291.412 605.667 291.277V291.185C605.667 291.13 605.624 291.109 605.569 291.136C605.541 291.151 605.517 291.173 605.5 291.198C605.483 291.224 605.473 291.252 605.471 291.282V291.374C605.471 291.634 605.68 291.742 605.937 291.607C606.071 291.53 606.183 291.427 606.263 291.304C606.343 291.182 606.388 291.044 606.396 290.903V288.374L608.612 287.243Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.249 290.789L603.157 293.897V287.682L609.249 284.574V290.789ZM603.396 293.54L609.01 290.67V284.942L603.396 287.811V293.54Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.861 287.411L609.776 290.524V284.303L615.861 281.195V287.411ZM610.008 290.161L615.629 287.292V281.558L610.008 284.422V290.161Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.945 283.079V284.644C613.928 284.923 613.837 285.195 613.679 285.437C613.522 285.68 613.303 285.887 613.039 286.041L612.653 286.236C612.157 286.49 611.747 286.285 611.747 285.77V284.2L612.861 283.631L612.616 284.216L613.088 283.973L612.445 285.711L613.504 283.594L613.021 283.843L613.272 283.426L613.945 283.079Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.02 287.746L612.684 287.92V285.954L613.02 285.786V287.746Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.849 287.676L611.692 288.64L613.951 287.486L612.849 287.676Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.437 284.065L616.345 287.178V280.957L622.437 277.849V284.065ZM616.584 286.815L622.198 283.946V278.212L616.584 281.076V286.815Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.825 283.464L616.927 285.971L619.376 280.318L621.825 283.464ZM617.386 285.44L621.341 283.42L619.345 280.897L617.386 285.44Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.161 283.94C619.164 283.873 619.185 283.807 619.222 283.749C619.259 283.691 619.312 283.641 619.376 283.604C619.504 283.539 619.584 283.604 619.584 283.724C619.584 283.79 619.565 283.856 619.529 283.915C619.492 283.974 619.44 284.023 619.376 284.059C619.247 284.124 619.161 284.07 619.161 283.94ZM619.253 283.372L619.198 281.639L619.547 281.466L619.492 283.247L619.253 283.372Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.794 288.407L573.934 296.139V311.607L558.794 303.876V288.407Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.794 288.407L573.934 296.139V296.285L558.794 288.591V288.407Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.178 283.253L573.934 296.139V311.608L599.178 298.716V283.253Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.794 288.407L573.934 296.139L599.178 283.252L584.037 275.521L558.794 288.407Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M594.133 280.675L568.896 293.567L563.839 290.984L589.082 278.098L594.133 280.675Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M568.896 293.567L568.89 298.716L563.839 296.139V290.984L568.896 293.567Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.69 300.486C582.537 299.734 581.551 299.593 580.369 300.2C580.227 300.271 580.09 300.35 579.959 300.438C579.85 300.502 579.746 300.573 579.647 300.649C579.311 300.903 579.009 301.19 578.747 301.504C578.402 301.901 578.165 302.362 578.055 302.853L580.283 301.716V304.239C580.278 304.322 580.251 304.403 580.204 304.475C580.157 304.547 580.092 304.609 580.014 304.656C579.861 304.731 579.739 304.656 579.739 304.515V304.434C579.739 304.379 579.696 304.358 579.647 304.385C579.618 304.4 579.595 304.422 579.578 304.447C579.561 304.473 579.551 304.501 579.549 304.531V304.623C579.549 304.883 579.757 304.986 580.014 304.856C580.148 304.777 580.259 304.672 580.338 304.549C580.418 304.426 580.464 304.288 580.473 304.147V301.624L582.69 300.486Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.326 304.033L577.234 307.141V300.925L583.326 297.812V304.033ZM577.473 306.778L583.088 303.914V298.174L577.473 301.044V306.778Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.939 300.643L583.853 303.751V297.536L589.939 294.428V300.643ZM584.086 303.388L589.706 300.524V294.785L584.086 297.655V303.388Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.022 296.312V297.882C588.005 298.162 587.914 298.434 587.755 298.677C587.597 298.92 587.376 299.126 587.11 299.279L586.73 299.474C586.228 299.728 585.818 299.517 585.818 299.008V297.438L586.933 296.897L586.688 297.481L587.165 297.238L586.516 298.976L587.582 296.859L587.098 297.102L587.343 296.686L588.022 296.312Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.092 300.99L586.755 301.163V299.198L587.092 299.025V300.99Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.926 300.92L585.769 301.883L588.022 300.73L586.926 300.92Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.496 297.308L590.373 300.416V294.2L596.496 291.092V297.308ZM590.643 300.053L596.257 297.189V291.439L590.643 294.309V300.053Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.908 296.702L591.01 299.214L593.459 293.562L595.908 296.702ZM591.469 298.683L595.424 296.664L593.429 294.141L591.469 298.683Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.239 297.184C593.238 297.117 593.257 297.051 593.294 296.992C593.33 296.933 593.383 296.884 593.447 296.848C593.575 296.783 593.661 296.848 593.661 296.967C593.66 297.034 593.64 297.101 593.603 297.159C593.565 297.218 593.512 297.267 593.447 297.303C593.324 297.395 593.239 297.308 593.239 297.184ZM593.324 296.642L593.276 294.91L593.618 294.736L593.569 296.518L593.324 296.642Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.506 283.177L615.653 290.914V306.377L600.506 298.646V283.177Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.506 283.177L615.653 290.914V291.055L600.506 283.366V283.177Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.896 278.022L615.653 290.914V306.377L640.896 293.491V278.022Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.506 283.177L615.653 290.914L640.896 278.022L625.749 270.291L600.506 283.177Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M635.845 275.45L610.614 288.337L605.557 285.759L630.794 272.868L635.845 275.45Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M610.614 288.336L610.602 293.491L605.557 290.914V285.759L610.614 288.336Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.402 295.256C624.249 294.504 623.269 294.363 622.082 294.969C621.94 295.042 621.803 295.121 621.671 295.207C621.567 295.272 621.463 295.348 621.359 295.424C621.024 295.676 620.722 295.961 620.459 296.274C620.114 296.67 619.879 297.131 619.773 297.622L621.996 296.485V299.019C621.989 299.101 621.962 299.181 621.915 299.252C621.868 299.324 621.804 299.385 621.727 299.431C621.58 299.506 621.457 299.431 621.457 299.295V299.203C621.457 299.149 621.414 299.127 621.359 299.154C621.331 299.171 621.307 299.194 621.29 299.22C621.273 299.246 621.263 299.276 621.261 299.306V299.393C621.261 299.653 621.469 299.761 621.727 299.631C621.861 299.553 621.973 299.448 622.054 299.325C622.135 299.202 622.182 299.064 622.192 298.922V296.393L624.402 295.256Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.039 298.803L618.947 301.91V295.695L625.039 292.587V298.803ZM619.186 301.553L624.8 298.683V292.95L619.186 295.814V301.553Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.657 295.424L625.566 298.537V292.316L631.657 289.208V295.424ZM625.804 298.174L631.419 295.305V289.571L625.804 292.435V298.174Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.735 291.092V292.657C629.719 292.937 629.629 293.209 629.471 293.452C629.314 293.694 629.094 293.901 628.829 294.054L628.449 294.249C627.947 294.503 627.537 294.298 627.537 293.783V292.213L628.651 291.672L628.406 292.257L628.878 292.018L628.235 293.751L629.294 291.634L628.81 291.883L629.061 291.466L629.735 291.092Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.81 295.76L628.474 295.933V293.968L628.81 293.8V295.76Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.639 295.689L627.482 296.653L629.741 295.5L628.639 295.689Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.208 292.078L632.086 295.191V288.97L638.208 285.862V292.078ZM632.355 294.828L637.97 291.959V286.225L632.355 289.089V294.828Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.621 291.477L632.723 293.984L635.172 288.331L637.621 291.477ZM633.188 293.453L637.131 291.439L635.135 288.91L633.188 293.453Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.951 291.981C634.954 291.913 634.975 291.848 635.012 291.789C635.049 291.731 635.102 291.681 635.166 291.645C635.294 291.58 635.374 291.645 635.374 291.764C635.374 291.831 635.355 291.897 635.319 291.956C635.282 292.014 635.23 292.064 635.166 292.1C635.037 292.138 634.951 292.083 634.951 291.981ZM635.043 291.439L634.994 289.706L635.337 289.533L635.288 291.315L635.043 291.439Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.583 296.42L589.731 304.152V319.621L574.583 311.889V296.42Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.583 296.42L589.731 304.152V304.298L574.583 296.604V296.42Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.968 291.266L589.731 304.152V319.621L614.968 306.729V291.266Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.583 296.42L589.731 304.152L614.967 291.266L599.827 283.534L574.583 296.42Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M609.923 288.689L584.686 301.58L579.628 299.003L604.871 286.111L609.923 288.689Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M584.686 301.58L584.679 306.729L579.628 304.152V299.003L584.686 301.58Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.48 308.5C598.327 307.747 597.341 307.606 596.159 308.213C596.017 308.284 595.88 308.364 595.749 308.451C595.64 308.517 595.535 308.589 595.437 308.667C595.099 308.918 594.797 309.203 594.537 309.518C594.192 309.914 593.955 310.375 593.845 310.866L596.073 309.729V312.252C596.068 312.335 596.041 312.416 595.994 312.488C595.947 312.56 595.882 312.622 595.804 312.669C595.651 312.744 595.529 312.669 595.529 312.533V312.441C595.529 312.387 595.486 312.365 595.437 312.393C595.408 312.408 595.385 312.43 595.368 312.455C595.35 312.481 595.341 312.509 595.339 312.539V312.631C595.339 312.891 595.547 312.994 595.804 312.864C595.938 312.785 596.049 312.68 596.128 312.557C596.208 312.434 596.254 312.296 596.263 312.154V309.631L598.48 308.5Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.116 312.046L593.024 315.154V308.938L599.116 305.83V312.046ZM593.263 314.791L598.878 311.927V306.188L593.263 309.057V314.791Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.729 308.668L599.643 311.775V305.56L605.729 302.452V308.668ZM599.875 311.418L605.496 308.548V302.809L599.875 305.679V311.418Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.812 304.336V305.901C603.795 306.181 603.704 306.453 603.545 306.696C603.387 306.939 603.166 307.145 602.9 307.298L602.52 307.493C602.018 307.747 601.608 307.536 601.608 307.027V305.457L602.722 304.888L602.478 305.473L602.955 305.229L602.343 306.967L603.402 304.85L602.918 305.094L603.163 304.683L603.812 304.336Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.888 309.003L602.545 309.177V307.211L602.888 307.038V309.003Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.716 308.933L601.559 309.897L603.818 308.743L602.716 308.933Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.286 305.321L606.163 308.429V302.214L612.286 299.106V305.321ZM606.433 308.072L612.047 305.202V299.463L606.433 302.333V308.072Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.698 304.715L606.8 307.227L609.249 301.575L611.698 304.715ZM607.259 306.697L611.214 304.677L609.218 302.154L607.259 306.697Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.029 305.197C609.029 305.13 609.049 305.065 609.085 305.006C609.121 304.947 609.173 304.898 609.237 304.861C609.365 304.796 609.451 304.861 609.451 304.98C609.45 305.048 609.43 305.114 609.393 305.172C609.355 305.231 609.301 305.281 609.237 305.316C609.114 305.381 609.029 305.321 609.029 305.197ZM609.114 304.628L609.065 302.896L609.408 302.723L609.359 304.504L609.114 304.628Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.137 291.098L631.284 298.83L631.278 314.298L616.137 306.561V291.098Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.137 291.098L631.284 298.83V298.976L616.137 291.282V291.098Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.521 285.943L631.284 298.83L631.278 314.298L656.521 301.407V285.943Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.137 291.098L631.284 298.83L656.521 285.943L641.38 278.212L616.137 291.098Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M651.476 283.366L626.239 296.258L621.182 293.675L646.425 280.789L651.476 283.366Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M626.239 296.258L626.233 301.407L621.182 298.83V293.675L626.239 296.258Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.033 303.177C639.88 302.419 638.894 302.279 637.713 302.885C637.571 302.958 637.434 303.038 637.302 303.123C637.192 303.194 637.088 303.264 636.99 303.34C636.651 303.591 636.349 303.878 636.09 304.195C635.745 304.592 635.508 305.053 635.398 305.543L637.627 304.406V306.93C637.621 307.013 637.594 307.093 637.547 307.166C637.5 307.238 637.436 307.3 637.358 307.346C637.204 307.422 637.082 307.346 637.082 307.206V307.141C637.082 307.087 637.039 307.065 636.99 307.092C636.962 307.108 636.938 307.129 636.921 307.154C636.904 307.18 636.894 307.209 636.892 307.238V307.325C636.892 307.585 637.1 307.693 637.358 307.563C637.491 307.484 637.602 307.379 637.682 307.256C637.761 307.133 637.808 306.995 637.817 306.854V304.331L640.033 303.177Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.67 306.724L634.547 309.832V303.611L640.67 300.503V306.724ZM634.816 309.469L640.431 306.599V300.865L634.816 303.735V309.469Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.282 303.351L641.196 306.458V300.243L647.282 297.13V303.351ZM641.429 306.096L647.049 303.232V297.492L641.429 300.362V306.096Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.366 299.019V300.589C645.347 300.869 645.255 301.141 645.097 301.383C644.938 301.626 644.718 301.832 644.453 301.986L644.074 302.176C643.572 302.436 643.162 302.224 643.162 301.715V300.145L644.276 299.604L644.031 300.189L644.509 299.945L643.86 301.683L644.925 299.566L644.441 299.81L644.686 299.393L645.366 299.019Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.435 303.681L644.098 303.854V301.889L644.435 301.715V303.681Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.27 303.605L643.113 304.574L645.366 303.421L644.27 303.605Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.839 299.999L647.747 303.107V296.891L653.839 293.778V299.999ZM647.986 302.744L653.6 299.88V294.146L647.986 297.016V302.744Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.251 299.393L648.353 301.905L650.802 296.252L653.251 299.393ZM648.813 301.374L652.768 299.355L650.772 296.826L648.813 301.374Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.6 299.875C650.6 299.808 650.619 299.742 650.655 299.683C650.692 299.624 650.745 299.575 650.809 299.539C650.937 299.474 651.023 299.539 651.023 299.658C651.02 299.725 651 299.791 650.962 299.849C650.925 299.907 650.872 299.957 650.809 299.994C650.668 300.053 650.6 299.999 650.6 299.875ZM650.686 299.301L650.637 297.573L650.98 297.395L650.931 299.176L650.686 299.301Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.208 304.341L605.355 312.073V327.537L590.208 319.805V304.341Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.208 304.341L605.355 312.073V312.219L590.208 304.526V304.341Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.598 299.187L605.355 312.073V327.537L630.598 314.65V299.187Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.208 304.341L605.355 312.073L630.598 299.187L615.451 291.45L590.208 304.341Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M625.547 296.61L600.316 309.501L595.259 306.919L620.502 294.032L625.547 296.61Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M600.316 309.501L600.31 314.65L595.259 312.073V306.919L600.316 309.501Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.11 316.415C613.951 315.663 612.972 315.522 611.784 316.129C611.642 316.201 611.505 316.281 611.373 316.367L611.061 316.583C610.726 316.836 610.426 317.123 610.167 317.439C609.823 317.834 609.587 318.293 609.476 318.782L611.704 317.645V320.173C611.698 320.257 611.67 320.338 611.622 320.41C611.574 320.483 611.508 320.544 611.429 320.59C611.282 320.666 611.159 320.59 611.159 320.449V320.363C611.159 320.308 611.116 320.287 611.061 320.314C611.035 320.331 611.013 320.352 610.997 320.378C610.981 320.403 610.972 320.431 610.969 320.46V320.547C610.969 320.807 611.178 320.915 611.429 320.785C611.564 320.707 611.677 320.603 611.757 320.48C611.838 320.356 611.885 320.218 611.894 320.076V317.547L614.11 316.415Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.741 319.962L608.655 323.075V316.854L614.741 313.746V319.962ZM608.888 322.712L614.508 319.843V314.109L608.888 316.973V322.712Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.359 316.589L615.267 319.696V313.475L621.359 310.368V316.589ZM615.506 319.334L621.121 316.464V310.73L615.506 313.6V319.334Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.443 312.252V313.822C619.425 314.101 619.333 314.372 619.175 314.614C619.016 314.856 618.796 315.061 618.531 315.214L618.151 315.408C617.649 315.663 617.239 315.457 617.239 314.943V313.378L618.353 312.837L618.108 313.416L618.58 313.178L617.968 314.91L619.027 312.793L618.543 313.042L618.794 312.625L619.443 312.252Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.512 316.924L618.176 317.092V315.132L618.512 314.959V316.924Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.347 316.849L617.19 317.812L619.443 316.665L618.347 316.849Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.91 313.243L621.825 316.345V310.124L627.91 307.016V313.243ZM622.057 315.988L627.678 313.118V307.384L622.057 310.254V315.988Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.335 312.636L622.437 315.149L624.886 309.49L627.335 312.636ZM622.902 314.613L626.851 312.598L624.861 310.07L622.902 314.613Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.653 313.096C624.656 313.029 624.677 312.964 624.714 312.905C624.751 312.847 624.804 312.797 624.868 312.761C624.996 312.696 625.082 312.761 625.082 312.88C625.081 312.947 625.061 313.013 625.023 313.072C624.986 313.131 624.932 313.18 624.868 313.216C624.739 313.297 624.653 313.243 624.653 313.096ZM624.745 312.555L624.696 310.828L625.039 310.649L624.99 312.431L624.745 312.555Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.786 299.122L646.933 306.854V322.317L631.786 314.585V299.122Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.786 299.122L646.933 306.854V307L631.786 299.306V299.122Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.176 293.968L646.933 306.854V322.317L672.176 309.431V293.968Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.786 299.122L646.933 306.854L672.176 293.968L657.029 286.236L631.786 299.122Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M667.125 291.39L641.894 304.282L636.837 301.699L662.074 288.813L667.125 291.39Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M641.894 304.282L641.882 309.431L636.837 306.854V301.699L641.894 304.282Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.682 311.201C655.529 310.443 654.549 310.303 653.362 310.909C653.221 310.985 653.086 311.061 652.951 311.147L652.639 311.364C652.305 311.618 652.006 311.905 651.745 312.219C651.395 312.613 651.158 313.075 651.053 313.568L653.276 312.431V314.954C653.27 315.037 653.243 315.118 653.196 315.19C653.15 315.262 653.085 315.324 653.007 315.37C652.86 315.446 652.737 315.37 652.737 315.23V315.143C652.737 315.089 652.694 315.067 652.639 315.094C652.611 315.11 652.587 315.131 652.57 315.157C652.553 315.182 652.543 315.211 652.541 315.241V315.327C652.541 315.592 652.749 315.695 653.007 315.565C653.142 315.488 653.254 315.383 653.335 315.26C653.416 315.137 653.463 314.998 653.472 314.856V312.333L655.682 311.201Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.319 314.748L650.233 317.856V311.635L656.319 308.527V314.748ZM650.466 317.493L656.086 314.623V308.889L650.466 311.759V317.493Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.937 311.369L656.815 314.477V308.261L662.937 305.148V311.369ZM657.084 314.114L662.698 311.25V305.516L657.084 308.386V314.114Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.009 307.032V308.603C660.99 308.882 660.898 309.154 660.74 309.397C660.581 309.639 660.361 309.846 660.096 309.999L659.717 310.194C659.215 310.449 658.804 310.238 658.804 309.729V308.159L659.919 307.59L659.674 308.175L660.145 307.931L659.502 309.669L660.562 307.552L660.078 307.796L660.329 307.379L661.009 307.032Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.09 311.705L659.753 311.878V309.913L660.09 309.74V311.705Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.919 311.629L658.762 312.598L661.021 311.445L659.919 311.629Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.488 308.023L663.396 311.131V304.915L669.488 301.802V308.023ZM663.635 310.768L669.249 307.904V302.165L663.635 305.034V310.768Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.9 307.417L664.002 309.929L666.451 304.276L668.9 307.417ZM664.468 309.399L668.417 307.379L666.421 304.85L664.468 309.399Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.231 307.899C666.232 307.831 666.252 307.765 666.29 307.707C666.327 307.648 666.381 307.599 666.445 307.563C666.574 307.498 666.653 307.563 666.653 307.682C666.652 307.749 666.633 307.814 666.596 307.873C666.56 307.931 666.508 307.981 666.445 308.018C666.317 308.077 666.231 308.023 666.231 307.899ZM666.323 307.33L666.274 305.598L666.617 305.419L666.568 307.206L666.323 307.33Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.863 312.365L621.01 320.097V335.561L605.863 327.829V312.365Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.863 312.365L621.01 320.097V320.243L605.863 312.55V312.365Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.247 307.206L621.01 320.097V335.561L646.247 322.675V307.206Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.863 312.365L621.01 320.097L646.247 307.206L631.106 299.479L605.863 312.365Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M641.202 304.634L615.965 317.525L610.914 314.943L636.151 302.057L641.202 304.634Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M615.965 317.525L615.959 322.674L610.914 320.097V314.943L615.965 317.525Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.784 324.467C629.631 323.714 628.651 323.573 627.463 324.18C627.322 324.253 627.185 324.332 627.053 324.418C626.943 324.488 626.839 324.559 626.741 324.635C626.402 324.886 626.1 325.173 625.841 325.49C625.497 325.885 625.26 326.344 625.149 326.833L627.378 325.701V328.224C627.372 328.307 627.345 328.388 627.298 328.461C627.251 328.533 627.186 328.595 627.108 328.641C626.955 328.717 626.833 328.641 626.833 328.5V328.414C626.833 328.36 626.79 328.338 626.741 328.365C626.713 328.381 626.689 328.402 626.672 328.428C626.655 328.453 626.645 328.482 626.643 328.511V328.598C626.643 328.858 626.851 328.966 627.108 328.836C627.242 328.757 627.353 328.652 627.433 328.529C627.512 328.406 627.558 328.268 627.568 328.127V325.598L629.784 324.467Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.396 327.986L624.304 331.099V324.878L630.396 321.76V327.986ZM624.543 330.737L630.157 327.867V322.133L624.543 325.003V330.737Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.008 324.613L630.923 327.721V321.5L637.008 318.392V324.613ZM631.155 327.358L636.776 324.488V318.754L631.155 321.624V327.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.092 320.276V321.846C635.074 322.124 634.983 322.395 634.825 322.637C634.668 322.878 634.449 323.084 634.186 323.238L633.8 323.432C633.298 323.692 632.894 323.481 632.894 322.967V321.402L634.008 320.861L633.764 321.445L634.235 321.202L633.592 322.934L634.651 320.817L634.168 321.066L634.413 320.649L635.092 320.276Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.168 324.948L633.825 325.122V323.156L634.168 322.983V324.948Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.996 324.873L632.839 325.836L635.098 324.689L633.996 324.873Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.566 321.267L637.443 324.375V318.153L643.566 315.046V321.267ZM637.712 324.012L643.327 321.142V315.408L637.712 318.278V324.012Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.978 320.677L638.08 323.189L640.529 317.531L642.978 320.677ZM638.539 322.653L642.494 320.639L640.498 318.11L638.539 322.653Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.308 321.137C640.31 321.071 640.33 321.006 640.366 320.949C640.403 320.891 640.454 320.842 640.517 320.806C640.651 320.736 640.731 320.806 640.731 320.92C640.731 320.988 640.712 321.054 640.674 321.113C640.636 321.172 640.582 321.221 640.517 321.256C640.394 321.321 640.308 321.267 640.308 321.137ZM640.4 320.595L640.345 318.868L640.694 318.689L640.639 320.471L640.4 320.595Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.417 307.038L662.564 314.775L662.557 330.238L647.417 322.507V307.038Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.417 307.038L662.564 314.775V314.916L647.417 307.227V307.038Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.801 301.883L662.564 314.775L662.558 330.238L687.801 317.352V301.883Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.417 307.038L662.564 314.775L687.8 301.883L672.66 294.152L647.417 307.038Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M682.756 299.306L657.519 312.198L652.462 309.62L677.705 296.729L682.756 299.306Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M657.519 312.198L657.513 317.352L652.462 314.775V309.62L657.519 312.198Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.313 319.117C671.16 318.365 670.18 318.224 668.992 318.83C668.85 318.901 668.713 318.981 668.582 319.069C668.473 319.135 668.369 319.207 668.27 319.285C667.933 319.536 667.63 319.821 667.37 320.135C667.025 320.531 666.788 320.993 666.678 321.483L668.906 320.346V322.875C668.9 322.957 668.872 323.037 668.826 323.108C668.779 323.179 668.714 323.24 668.637 323.286C668.484 323.362 668.362 323.286 668.362 323.151V323.059C668.362 323.005 668.319 322.983 668.27 323.01C668.241 323.027 668.218 323.049 668.201 323.076C668.184 323.102 668.174 323.131 668.172 323.162V323.248C668.172 323.508 668.38 323.617 668.637 323.487C668.77 323.408 668.881 323.303 668.961 323.18C669.04 323.056 669.087 322.919 669.096 322.777V320.249L671.313 319.117Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.95 322.664L665.858 325.771V319.556L671.95 316.448V322.664ZM666.096 325.414L671.711 322.544V316.811L666.096 319.675V325.414Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.562 319.285L672.476 322.398V316.177L678.562 313.069V319.285ZM672.709 322.036L678.329 319.166V313.432L672.709 316.296V322.036Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.645 314.954V316.518C676.628 316.798 676.537 317.071 676.378 317.313C676.22 317.556 675.999 317.762 675.733 317.915L675.353 318.11C674.851 318.365 674.441 318.159 674.441 317.645V316.074L675.555 315.533L675.311 316.118L675.788 315.879L675.176 317.612L676.235 315.495L675.751 315.744L675.996 315.327L676.645 314.954Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.715 319.621L675.384 319.794V317.829L675.715 317.661V319.621Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.549 319.55L674.392 320.514L676.645 319.361L675.549 319.55Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.119 315.939L678.996 319.052V312.831L685.119 309.723V315.939ZM679.266 318.689L684.88 315.82V310.086L679.266 312.95V318.689Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.531 315.338L679.633 317.845L682.082 312.192L684.531 315.338ZM680.092 317.314L684.047 315.295L682.052 312.772L680.092 317.314Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.862 315.804C681.863 315.737 681.883 315.672 681.919 315.613C681.955 315.555 682.007 315.505 682.07 315.468C682.198 315.403 682.284 315.468 682.284 315.587C682.283 315.654 682.263 315.721 682.226 315.779C682.188 315.838 682.135 315.887 682.07 315.923C681.947 315.999 681.862 315.944 681.862 315.804ZM681.947 315.262L681.899 313.53L682.241 313.356L682.192 315.138L681.947 315.262Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.494 320.281L636.635 328.013V343.482L621.494 335.75V320.281Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.494 320.281L636.635 328.013V328.159L621.494 320.465V320.281Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.878 315.127L636.635 328.013V343.482L661.878 330.59V315.127Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.494 320.281L636.635 328.013L661.878 315.127L646.731 307.395L621.494 320.281Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M656.827 312.55L631.596 325.441L626.539 322.859L651.782 309.972L656.827 312.55Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M631.596 325.441L631.59 330.59L626.539 328.013V322.859L631.596 325.441Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.39 332.361C645.231 331.608 644.251 331.468 643.063 332.074C642.929 332.144 642.788 332.225 642.653 332.312C642.519 332.399 642.445 332.453 642.341 332.529C642.007 332.781 641.707 333.066 641.447 333.379C641.102 333.775 640.865 334.236 640.755 334.727L642.984 333.59V336.113C642.978 336.197 642.949 336.278 642.902 336.35C642.854 336.422 642.788 336.484 642.708 336.53C642.561 336.606 642.439 336.53 642.439 336.395V336.302C642.439 336.248 642.396 336.227 642.341 336.254C642.314 336.271 642.292 336.292 642.276 336.318C642.261 336.343 642.251 336.371 642.249 336.4V336.492C642.249 336.752 642.457 336.855 642.708 336.725C642.844 336.647 642.956 336.543 643.037 336.419C643.118 336.296 643.165 336.158 643.174 336.016V333.492L645.39 332.361Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.021 335.907L639.935 339.015V332.799L646.021 329.686V335.907ZM640.168 338.652L645.788 335.788V330.049L640.168 332.919V338.652Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.639 332.529L646.547 335.637V329.421L652.639 326.313V332.529ZM646.786 335.279L652.4 332.41V326.67L646.786 329.54V335.279Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.723 328.192V329.762C650.706 330.042 650.614 330.314 650.456 330.557C650.297 330.8 650.076 331.006 649.811 331.159L649.431 331.354C648.929 331.608 648.519 331.397 648.519 330.888V329.34L649.633 328.798L649.388 329.383L649.866 329.139L649.217 330.877L650.276 328.76L649.792 329.004L650.043 328.587L650.723 328.192Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.792 332.864L649.455 333.038V331.072L649.792 330.899V332.864Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.627 332.794L648.47 333.758L650.723 332.604L649.627 332.794Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.172 329.183L653.086 332.29V326.091L659.172 322.983V329.183ZM653.319 331.933L658.939 329.063V323.324L653.319 326.194V331.933Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.609 328.576L653.711 331.088L656.16 325.436L658.609 328.576ZM654.17 330.558L658.119 328.538L656.129 326.015L654.17 330.558Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.939 329.058C655.939 328.991 655.958 328.925 655.994 328.866C656.031 328.808 656.083 328.758 656.147 328.722C656.276 328.657 656.362 328.722 656.362 328.841C656.361 328.909 656.341 328.975 656.303 329.034C656.266 329.092 656.212 329.142 656.147 329.177C656.025 329.242 655.939 329.183 655.939 329.058ZM656.025 328.517L655.976 326.784L656.319 326.611L656.27 328.392L656.025 328.517Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.716 259.137L599.863 266.869V282.337L584.716 274.606V259.137Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.716 259.137L599.863 266.869V267.015L584.716 259.321V259.137Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.106 253.982L599.863 266.869V282.337L625.106 269.446V253.982Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.716 259.137L599.863 266.869L625.106 253.982L609.959 246.251L584.716 259.137Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M620.055 251.405L594.818 264.297L589.767 261.72L615.004 248.828L620.055 251.405Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M594.818 264.297L594.812 269.446L589.767 266.869V261.72L594.818 264.297Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.612 271.216C608.459 270.464 607.479 270.323 606.292 270.929C606.15 271.002 606.013 271.081 605.882 271.168C605.772 271.234 605.668 271.306 605.569 271.384C605.232 271.635 604.93 271.92 604.669 272.234C604.324 272.631 604.088 273.092 603.978 273.582L606.206 272.445V274.968C606.2 275.052 606.173 275.132 606.127 275.205C606.08 275.277 606.015 275.339 605.937 275.385C605.784 275.461 605.667 275.385 605.667 275.25V275.158C605.667 275.104 605.624 275.082 605.569 275.109C605.541 275.125 605.517 275.146 605.5 275.172C605.483 275.197 605.473 275.226 605.471 275.255V275.347C605.471 275.607 605.68 275.71 605.937 275.58C606.072 275.503 606.183 275.398 606.263 275.275C606.343 275.151 606.389 275.013 606.396 274.871V272.348L608.612 271.216Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.249 274.763L603.157 277.871V271.655L609.249 268.547V274.763ZM603.396 277.508L609.01 274.644V268.904L603.396 271.774V277.508Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.861 271.406L609.776 274.514V268.298L615.861 265.19V271.406ZM610.008 274.156L615.629 271.287V265.553L610.008 268.417V274.156Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.945 267.074V268.639C613.928 268.918 613.837 269.19 613.679 269.433C613.522 269.675 613.303 269.882 613.039 270.036L612.653 270.231C612.157 270.485 611.747 270.274 611.747 269.765V268.157L612.861 267.616L612.616 268.201L613.088 267.957L612.445 269.695L613.504 267.578L613.021 267.827L613.272 267.41L613.945 267.074Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.02 271.72L612.684 271.893V269.928L613.02 269.754V271.72Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.849 271.649L611.692 272.613L613.951 271.46L612.849 271.649Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.437 268.038L616.345 271.146V264.909L622.437 261.801V268.038ZM616.584 270.789L622.198 267.919V262.201L616.584 265.066V270.789Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.825 267.437L616.927 269.944L619.376 264.291L621.825 267.437ZM617.386 269.413L621.341 267.394L619.345 264.871L617.386 269.413Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.161 267.914C619.164 267.847 619.185 267.781 619.222 267.723C619.259 267.664 619.312 267.614 619.376 267.578C619.504 267.513 619.584 267.578 619.584 267.697C619.584 267.764 619.565 267.83 619.529 267.889C619.492 267.947 619.44 267.997 619.376 268.033C619.247 268.098 619.161 268.044 619.161 267.914ZM619.253 267.372L619.198 265.64L619.547 265.466L619.492 267.248L619.253 267.372Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.794 272.38L573.934 280.112V295.581L558.794 287.844V272.38Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.794 272.38L573.934 280.112V280.258L558.794 272.564V272.38Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.178 267.226L573.934 280.112V295.581L599.178 282.689V267.226Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.794 272.38L573.934 280.112L599.178 267.226L584.037 259.494L558.794 272.38Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M594.133 264.649L568.896 277.54L563.839 274.958L589.082 262.071L594.133 264.649Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M568.896 277.54L568.89 282.689L563.839 280.112V274.958L568.896 277.54Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.69 284.46C582.537 283.707 581.551 283.566 580.369 284.167C580.228 284.239 580.091 284.316 579.959 284.4C579.849 284.471 579.745 284.541 579.647 284.617C579.311 284.871 579.009 285.158 578.747 285.472C578.402 285.869 578.165 286.33 578.055 286.821L580.283 285.684V288.207C580.278 288.29 580.251 288.371 580.204 288.443C580.157 288.515 580.092 288.577 580.014 288.624C579.861 288.699 579.739 288.624 579.739 288.483V288.396C579.739 288.342 579.696 288.32 579.647 288.347C579.618 288.363 579.595 288.384 579.578 288.41C579.561 288.435 579.551 288.464 579.549 288.494V288.58C579.549 288.846 579.757 288.948 580.014 288.818C580.148 288.74 580.259 288.635 580.338 288.512C580.418 288.389 580.464 288.251 580.473 288.109V285.586L582.69 284.46Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.326 288.006L577.234 291.114V284.898L583.326 281.785V288.006ZM577.473 290.751L583.088 287.887V282.148L577.473 285.018V290.751Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.939 284.628L583.853 287.736V281.52L589.939 278.407V284.628ZM584.086 287.373L589.706 284.509V278.769L584.086 281.639V287.373Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.022 280.291V281.861C588.004 282.141 587.913 282.413 587.754 282.655C587.596 282.898 587.375 283.104 587.11 283.258L586.73 283.453C586.228 283.707 585.818 283.496 585.818 282.987V281.417L586.933 280.876L586.688 281.46L587.165 281.217L586.516 282.955L587.582 280.838L587.098 281.081L587.343 280.664L588.022 280.291Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.092 284.963L586.755 285.137V283.171L587.092 282.998V284.963Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.926 284.888L585.769 285.857L588.022 284.703L586.926 284.888Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.496 281.282L590.373 284.389V278.174L596.496 275.066V281.282ZM590.643 284.027L596.257 281.162V275.423L590.643 278.293V284.027Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.908 280.675L591.01 283.188L593.459 277.535L595.908 280.675ZM591.469 282.657L595.424 280.637L593.429 278.109L591.469 282.657Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.239 281.152C593.238 281.085 593.257 281.019 593.294 280.96C593.33 280.901 593.383 280.852 593.447 280.816C593.575 280.751 593.661 280.816 593.661 280.935C593.659 281.002 593.638 281.068 593.601 281.126C593.563 281.185 593.51 281.234 593.447 281.271C593.324 281.336 593.239 281.282 593.239 281.152ZM593.324 280.61L593.276 278.878L593.618 278.699L593.569 280.486L593.324 280.61Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.506 267.15L615.653 274.887V290.351L600.506 282.619V267.15Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.506 267.15L615.653 274.887V275.028L600.506 267.334V267.15Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.896 261.996L615.653 274.887V290.351L640.896 277.465V261.996Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.506 267.15L615.653 274.887L640.896 261.996L625.749 254.264L600.506 267.15Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M635.845 259.418L610.614 272.31L605.557 269.733L630.794 256.841L635.845 259.418Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M610.614 272.31L610.602 277.465L605.557 274.882V269.733L610.614 272.31Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.402 279.23C624.249 278.477 623.269 278.336 622.082 278.943C621.94 279.015 621.803 279.095 621.671 279.181C621.567 279.246 621.463 279.322 621.359 279.397C621.024 279.65 620.722 279.935 620.459 280.248C620.114 280.643 619.879 281.105 619.773 281.596L621.996 280.459V282.987C621.989 283.069 621.962 283.149 621.915 283.221C621.868 283.292 621.804 283.353 621.727 283.399C621.58 283.474 621.457 283.399 621.457 283.263V283.171C621.457 283.117 621.414 283.095 621.359 283.123C621.331 283.138 621.307 283.16 621.29 283.185C621.273 283.211 621.263 283.239 621.261 283.269V283.361C621.261 283.621 621.469 283.724 621.727 283.594C621.862 283.516 621.975 283.412 622.056 283.289C622.137 283.165 622.184 283.027 622.192 282.884V280.361L624.402 279.23Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.039 282.776L618.947 285.884V279.668L625.039 276.56V282.776ZM619.186 285.526L624.8 282.657V276.918L619.186 279.787V285.526Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.657 279.397L625.566 282.505V276.279L631.657 273.171V279.397ZM625.804 282.148L631.419 279.278V273.572L625.804 276.436V282.148Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.735 275.066V276.631C629.719 276.91 629.629 277.182 629.471 277.425C629.314 277.668 629.094 277.874 628.829 278.028L628.449 278.222C627.947 278.477 627.537 278.271 627.537 277.757V276.187L628.651 275.645L628.406 276.23L628.878 275.986L628.235 277.724L629.294 275.607L628.81 275.856L629.061 275.439L629.735 275.066Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.81 279.733L628.474 279.906V277.941L628.81 277.768V279.733Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.639 279.663L627.482 280.627L629.741 279.473L628.639 279.663Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.208 276.051L632.086 279.159V272.944L638.208 269.836V276.051ZM632.355 278.802L637.97 275.932V270.198L632.355 273.063V278.802Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.621 275.45L632.723 277.957L635.172 272.305L637.621 275.45ZM633.188 277.427L637.137 275.407L635.141 272.884L633.188 277.427Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.951 275.927C634.954 275.86 634.975 275.794 635.012 275.736C635.049 275.677 635.102 275.628 635.166 275.591C635.294 275.526 635.374 275.591 635.374 275.71C635.374 275.777 635.355 275.843 635.319 275.902C635.282 275.961 635.23 276.01 635.166 276.046C635.037 276.111 634.951 276.057 634.951 275.927ZM635.043 275.385L634.994 273.653L635.337 273.479L635.288 275.261L635.043 275.385Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.583 280.394L589.731 288.125V303.594L574.583 295.863V280.394Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.583 280.394L589.731 288.125V288.272L574.583 280.578V280.394Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.968 275.239L589.731 288.125V303.594L614.968 290.703V275.239Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.583 280.394L589.731 288.125L614.967 275.239L599.827 267.508L574.583 280.394Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M609.923 272.662L584.686 285.554L579.628 282.971L604.871 270.085L609.923 272.662Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M584.686 285.554L584.679 290.703L579.628 288.125V282.971L584.686 285.554Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.48 292.473C598.327 291.721 597.341 291.58 596.159 292.186C596.018 292.257 595.881 292.335 595.749 292.419C595.639 292.489 595.535 292.56 595.437 292.636C595.101 292.889 594.799 293.177 594.537 293.491C594.192 293.887 593.955 294.349 593.845 294.839L596.073 293.702V296.225C596.068 296.308 596.041 296.389 595.994 296.462C595.947 296.534 595.882 296.596 595.804 296.642C595.651 296.718 595.529 296.642 595.529 296.501V296.415C595.529 296.361 595.486 296.339 595.437 296.366C595.408 296.382 595.385 296.403 595.368 296.429C595.35 296.454 595.341 296.483 595.339 296.512V296.604C595.339 296.864 595.547 296.967 595.804 296.837C595.938 296.758 596.049 296.653 596.128 296.53C596.208 296.407 596.254 296.269 596.263 296.128V293.605L598.48 292.473Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.116 296.02L593.024 299.127V292.912L599.116 289.798V296.02ZM593.263 298.765L598.878 295.9V290.161L593.263 293.031V298.765Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.729 292.641L599.643 295.749V289.533L605.729 286.425V292.641ZM599.875 295.386L605.496 292.522V286.783L599.875 289.652V295.386Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.812 288.304V289.874C603.795 290.154 603.704 290.427 603.545 290.669C603.387 290.912 603.166 291.118 602.9 291.271L602.52 291.466C602.018 291.721 601.608 291.509 601.608 291V289.43L602.722 288.889L602.478 289.474L602.955 289.23L602.343 290.968L603.402 288.851L602.918 289.095L603.163 288.678L603.812 288.304Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.888 292.977L602.545 293.15V291.184L602.888 291.011V292.977Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.716 292.906L601.559 293.87L603.818 292.717L602.716 292.906Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.286 289.273L606.163 292.381V286.187L612.286 283.079V289.273ZM606.433 292.018L612.047 289.154V283.415L606.433 286.284V292.018Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.698 288.689L606.8 291.201L609.249 285.548L611.698 288.689ZM607.259 290.67L611.214 288.651L609.218 286.122L607.259 290.67Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.029 289.17C609.028 289.103 609.047 289.037 609.084 288.979C609.12 288.92 609.173 288.87 609.237 288.835C609.365 288.77 609.451 288.835 609.451 288.954C609.45 289.021 609.43 289.087 609.393 289.146C609.355 289.205 609.301 289.254 609.237 289.29C609.114 289.355 609.029 289.273 609.029 289.17ZM609.114 288.629L609.065 286.896L609.408 286.723L609.359 288.504L609.114 288.629Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.137 275.071L631.284 282.803L631.278 298.267L616.137 290.535V275.071Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.137 275.071L631.284 282.803V282.949L616.137 275.255V275.071Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.521 269.917L631.284 282.803L631.278 298.266L656.521 285.38V269.917Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.137 275.071L631.284 282.803L656.521 269.917L641.38 262.185L616.137 275.071Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M651.476 267.34L626.239 280.231L621.182 277.649L646.425 264.762L651.476 267.34Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M626.239 280.231L626.233 285.38L621.182 282.803V277.649L626.239 280.231Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.033 287.145C639.88 286.393 638.894 286.252 637.713 286.858C637.571 286.932 637.434 287.011 637.302 287.097C637.192 287.167 637.088 287.237 636.99 287.313C636.651 287.565 636.349 287.852 636.09 288.169C635.744 288.564 635.507 289.026 635.398 289.517L637.627 288.38V290.898C637.621 290.981 637.594 291.062 637.547 291.134C637.5 291.206 637.436 291.268 637.358 291.314C637.204 291.39 637.082 291.314 637.082 291.174V291.087C637.082 291.033 637.039 291.011 636.99 291.038C636.962 291.054 636.938 291.075 636.921 291.101C636.904 291.126 636.894 291.155 636.892 291.185V291.271C636.892 291.531 637.1 291.639 637.358 291.509C637.491 291.431 637.602 291.326 637.682 291.203C637.761 291.079 637.808 290.942 637.817 290.8V288.272L640.033 287.145Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.67 290.697L634.547 293.805V287.584L640.67 284.476V290.697ZM634.816 293.442L640.431 290.573V284.839L634.816 287.709V293.442Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.282 287.319L641.196 290.427V284.205L647.282 281.098V287.319ZM641.429 290.064L647.049 287.194V281.46L641.429 284.33V290.064Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.366 282.982V284.552C645.348 284.831 645.256 285.102 645.097 285.344C644.939 285.586 644.718 285.791 644.453 285.943L644.074 286.138C643.572 286.398 643.162 286.187 643.162 285.673V284.108L644.276 283.567L644.031 284.151L644.509 283.908L643.86 285.64L644.925 283.523L644.441 283.772L644.686 283.355L645.366 282.982Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.435 287.654L644.098 287.828V285.862L644.435 285.689V287.654Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.27 287.579L643.113 288.542L645.366 287.394L644.27 287.579Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.839 283.973L647.747 287.08V280.859L653.839 277.751V283.973ZM647.986 286.718L653.6 283.848V278.114L647.986 280.984V286.718Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.251 283.366L648.353 285.878L650.802 280.22L653.251 283.366ZM648.813 285.348L652.768 283.328L650.772 280.8L648.813 285.348Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.6 283.859C650.601 283.793 650.62 283.728 650.657 283.67C650.693 283.613 650.745 283.564 650.809 283.529C650.937 283.458 651.023 283.529 651.023 283.648C651.021 283.714 651 283.779 650.963 283.837C650.925 283.895 650.872 283.943 650.809 283.978C650.668 284.027 650.6 283.973 650.6 283.859ZM650.686 283.317L650.637 281.59L650.98 281.412L650.931 283.193L650.686 283.317Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.208 288.315L605.355 296.047V311.51L590.208 303.778V288.315Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.208 288.315L605.355 296.047V296.187L590.208 288.499V288.315Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.598 283.155L605.355 296.047V311.51L630.598 298.624V283.155Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.208 288.315L605.355 296.047L630.598 283.155L615.451 275.423L590.208 288.315Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M625.547 280.583L600.316 293.469L595.259 290.892L620.502 278.006L625.547 280.583Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M600.316 293.469L600.31 298.624L595.259 296.047V290.892L600.316 293.469Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.11 300.389C613.951 299.636 612.972 299.496 611.784 300.102C611.642 300.174 611.505 300.254 611.373 300.34L611.061 300.557C610.726 300.81 610.426 301.097 610.167 301.412C609.823 301.807 609.587 302.266 609.476 302.755L611.704 301.618V304.147C611.697 304.229 611.668 304.309 611.621 304.381C611.573 304.452 611.507 304.513 611.429 304.558C611.282 304.639 611.159 304.558 611.159 304.423V304.336C611.159 304.282 611.116 304.26 611.061 304.287C611.035 304.304 611.013 304.326 610.997 304.351C610.981 304.377 610.972 304.405 610.969 304.434V304.52C610.969 304.78 611.178 304.888 611.429 304.758C611.564 304.681 611.677 304.576 611.757 304.453C611.838 304.33 611.885 304.191 611.894 304.049V301.521L614.11 300.389Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.741 303.935L608.655 307.049V300.827L614.741 297.72V303.935ZM608.888 306.686L614.508 303.816V298.082L608.888 300.947V306.686Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.359 300.557L615.267 303.67V297.449L621.359 294.341V300.557ZM615.506 303.307L621.121 300.438V294.688L615.506 297.557V303.307Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.443 296.225V297.796C619.425 298.074 619.333 298.346 619.175 298.588C619.016 298.829 618.796 299.035 618.531 299.187L618.151 299.382C617.649 299.636 617.239 299.431 617.239 298.916V297.352L618.353 296.783L618.108 297.362L618.58 297.124L617.968 298.857L619.027 296.74L618.543 296.989L618.794 296.572L619.443 296.225Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.512 300.898L618.176 301.066V299.1L618.512 298.932V300.898Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.347 300.822L617.19 301.786L619.443 300.633L618.347 300.822Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.91 297.211L621.825 300.324V294.103L627.91 290.995V297.211ZM622.057 299.961L627.678 297.092V291.358L622.057 294.227V299.961Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.335 296.61L622.437 299.117L624.886 293.464L627.335 296.61ZM622.902 298.586L626.851 296.572L624.861 294.043L622.902 298.586Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.653 297.086C624.656 297.019 624.677 296.954 624.714 296.895C624.751 296.837 624.804 296.787 624.868 296.751C624.996 296.686 625.082 296.751 625.082 296.87C625.081 296.937 625.061 297.003 625.023 297.062C624.986 297.12 624.932 297.17 624.868 297.205C624.739 297.27 624.653 297.216 624.653 297.086ZM624.745 296.545L624.696 294.812L625.039 294.639L624.99 296.42L624.745 296.545Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.786 283.095L646.933 290.827V306.296L631.786 298.559V283.095Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.786 283.095L646.933 290.827V290.973L631.786 283.28V283.095Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.176 277.941L646.933 290.827V306.296L672.176 293.404V277.941Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.786 283.095L646.933 290.827L672.176 277.941L657.029 270.209L631.786 283.095Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M667.125 275.364L641.894 288.255L636.837 285.673L662.074 272.786L667.125 275.364Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M641.894 288.255L641.882 293.404L636.837 290.827V285.673L641.894 288.255Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.682 295.175C655.529 294.417 654.549 294.276 653.362 294.883C653.221 294.958 653.086 295.034 652.951 295.121L652.639 295.337C652.304 295.59 652.004 295.877 651.745 296.193C651.395 296.586 651.158 297.049 651.053 297.541L653.276 296.404V298.927C653.27 299.01 653.243 299.091 653.196 299.163C653.15 299.236 653.085 299.298 653.007 299.344C652.86 299.42 652.737 299.344 652.737 299.203V299.117C652.737 299.062 652.694 299.041 652.639 299.068C652.611 299.083 652.587 299.105 652.57 299.13C652.553 299.156 652.543 299.185 652.541 299.214V299.301C652.541 299.561 652.749 299.669 653.007 299.539C653.142 299.461 653.254 299.357 653.335 299.234C653.416 299.11 653.463 298.972 653.472 298.83V296.312L655.682 295.175Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.319 298.721L650.233 301.829V295.608L656.319 292.5V298.721ZM650.466 301.466L656.086 298.597V292.863L650.466 295.733V301.466Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.937 295.343L656.815 298.451V292.235L662.937 289.122V295.343ZM657.084 298.088L662.698 295.224V289.484L657.084 292.354V298.088Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.009 291.006V292.576C660.99 292.856 660.898 293.128 660.74 293.37C660.581 293.613 660.361 293.819 660.096 293.973L659.717 294.162C659.215 294.422 658.804 294.211 658.804 293.702V292.132L659.919 291.591L659.674 292.175L660.145 291.932L659.502 293.67L660.562 291.553L660.078 291.796L660.329 291.379L661.009 291.006Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.09 295.678L659.753 295.852V293.886L660.09 293.713V295.678Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.919 295.603L658.762 296.572L661.021 295.419L659.919 295.603Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.488 291.98L663.396 295.088V288.873L669.488 285.759V291.98ZM663.635 294.725L669.249 291.861V286.122L663.635 288.992V294.725Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.9 291.39L664.002 293.903L666.451 288.25L668.9 291.39ZM664.468 293.372L668.417 291.352L666.421 288.824L664.468 293.372Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.231 291.872C666.232 291.805 666.252 291.739 666.29 291.68C666.327 291.621 666.381 291.572 666.445 291.536C666.574 291.471 666.653 291.536 666.653 291.656C666.653 291.722 666.633 291.786 666.597 291.844C666.561 291.902 666.508 291.951 666.445 291.986C666.317 292.051 666.231 291.98 666.231 291.872ZM666.323 291.298L666.274 289.571L666.617 289.392L666.568 291.174L666.323 291.298Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.863 296.339L621.01 304.071V319.534L605.863 311.802V296.339Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.863 296.339L621.01 304.071V304.217L605.863 296.523V296.339Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.247 291.179L621.01 304.071V319.534L646.247 306.648V291.179Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.863 296.339L621.01 304.071L646.247 291.179L631.106 283.447L605.863 296.339Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M641.202 288.607L615.965 301.499L610.914 298.916L636.151 286.03L641.202 288.607Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M615.965 301.499L615.959 306.648L610.914 304.071V298.916L615.965 301.499Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.784 308.413C629.631 307.66 628.651 307.52 627.463 308.126C627.321 308.197 627.184 308.277 627.053 308.364C626.943 308.435 626.839 308.505 626.741 308.581C626.402 308.832 626.1 309.12 625.841 309.436C625.497 309.831 625.26 310.291 625.149 310.779L627.378 309.642V312.171C627.372 312.254 627.345 312.335 627.298 312.407C627.251 312.479 627.186 312.541 627.108 312.588C626.955 312.663 626.833 312.588 626.833 312.447V312.36C626.833 312.306 626.79 312.284 626.741 312.311C626.713 312.327 626.689 312.348 626.672 312.374C626.655 312.399 626.645 312.428 626.643 312.458V312.544C626.643 312.804 626.851 312.912 627.108 312.782C627.242 312.704 627.353 312.599 627.433 312.476C627.512 312.353 627.558 312.215 627.568 312.073V309.545L629.784 308.413Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.396 311.959L624.304 315.073V308.852L630.396 305.744V311.959ZM624.543 314.71L630.157 311.84V306.106L624.543 308.971V314.71Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.008 308.586L630.923 311.694V305.473L637.008 302.365V308.586ZM631.155 311.331L636.776 308.462V302.728L631.155 305.598V311.331Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.092 304.249V305.82C635.074 306.098 634.983 306.368 634.825 306.61C634.668 306.852 634.449 307.057 634.186 307.211L633.8 307.406C633.298 307.66 632.894 307.455 632.894 306.94V305.376L634.008 304.834L633.764 305.413L634.235 305.175L633.592 306.908L634.651 304.791L634.168 305.04L634.413 304.623L635.092 304.249Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.168 308.922L633.825 309.09V307.13L634.168 306.957V308.922Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.996 308.846L632.839 309.81L635.098 308.662L633.996 308.846Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.566 305.24L637.443 308.348V302.127L643.566 299.019V305.24ZM637.712 307.985L643.327 305.116V299.382L637.743 302.268L637.712 307.985Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.978 304.634L638.08 307.141L640.529 301.488L642.978 304.634ZM638.539 306.61L642.494 304.596L640.498 302.067L638.539 306.61Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.308 305.11C640.311 305.044 640.331 304.979 640.367 304.92C640.403 304.862 640.454 304.812 640.517 304.775C640.651 304.71 640.731 304.775 640.731 304.894C640.731 304.961 640.712 305.028 640.674 305.087C640.636 305.145 640.582 305.195 640.517 305.229C640.394 305.294 640.308 305.24 640.308 305.11ZM640.4 304.569L640.345 302.842L640.694 302.663L640.639 304.444L640.4 304.569Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.417 291.011L662.564 298.748L662.557 314.212L647.417 306.48V291.011Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.417 291.011L662.564 298.748V298.889L647.417 291.201V291.011Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.801 285.857L662.564 298.748L662.558 314.212L687.801 301.32V285.857Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.417 291.011L662.564 298.748L687.8 285.857L672.66 278.125L647.417 291.011Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M682.756 283.28L657.519 296.171L652.462 293.594L677.705 280.702L682.756 283.28Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M657.519 296.171L657.513 301.32L652.462 298.743V293.594L657.519 296.171Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.313 303.091C671.16 302.338 670.18 302.197 668.992 302.804C668.85 302.875 668.713 302.955 668.582 303.042C668.473 303.108 668.369 303.18 668.27 303.259C667.933 303.509 667.63 303.794 667.37 304.109C667.025 304.505 666.788 304.966 666.678 305.457L668.906 304.32V306.848C668.9 306.93 668.872 307.01 668.826 307.082C668.779 307.153 668.714 307.214 668.637 307.26C668.484 307.336 668.362 307.26 668.362 307.124V307.032C668.362 306.978 668.319 306.957 668.27 306.984C668.241 306.999 668.218 307.021 668.201 307.046C668.184 307.072 668.174 307.1 668.172 307.13V307.222C668.172 307.482 668.38 307.585 668.637 307.455C668.771 307.377 668.883 307.272 668.963 307.149C669.042 307.025 669.088 306.887 669.096 306.745V304.222L671.313 303.091Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.95 306.637L665.858 309.745V303.529L671.95 300.421V306.637ZM666.096 309.388L671.711 306.518V300.779L666.096 303.648V309.388Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.562 303.259L672.476 306.366V300.151L678.562 297.043V303.259ZM672.709 306.009L678.329 303.139V297.395L672.709 300.259V306.009Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.645 298.927V300.492C676.628 300.772 676.537 301.044 676.378 301.287C676.22 301.53 675.999 301.736 675.733 301.889L675.353 302.084C674.851 302.338 674.441 302.127 674.441 301.618V300.048L675.555 299.479L675.311 300.064L675.788 299.82L675.176 301.558L676.235 299.441L675.751 299.691L675.996 299.274L676.645 298.927Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.715 303.594L675.384 303.768V301.802L675.715 301.634V303.594Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.549 303.524L674.392 304.488L676.645 303.334L675.549 303.524Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.119 299.912L678.996 303.02V296.805L685.119 293.697V299.912ZM679.266 302.663L684.88 299.793V294.059L679.266 296.924V302.663Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.531 299.311L679.633 301.818L682.082 296.166L684.531 299.311ZM680.092 301.288L684.047 299.268L682.052 296.745L680.092 301.288Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.862 299.788C681.863 299.721 681.883 299.656 681.919 299.597C681.955 299.539 682.007 299.489 682.07 299.452C682.198 299.387 682.284 299.452 682.284 299.571C682.283 299.639 682.263 299.705 682.226 299.764C682.188 299.822 682.135 299.872 682.07 299.907C681.947 299.972 681.862 299.918 681.862 299.788ZM681.947 299.219L681.899 297.487L682.241 297.314L682.192 299.095L681.947 299.219Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.494 304.255L636.635 311.986V327.455L621.494 319.718V304.255Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.494 304.255L636.635 311.986V312.133L621.494 304.439V304.255Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.878 299.1L636.635 311.987V327.455L661.878 314.564V299.1Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.494 304.255L636.635 311.987L661.878 299.1L646.731 291.369L621.494 304.255Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M656.827 296.523L631.596 309.415L626.539 306.832L651.782 293.946L656.827 296.523Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M631.596 309.415L631.59 314.564L626.539 311.986V306.832L631.596 309.415Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.39 316.345C645.231 315.592 644.251 315.452 643.063 316.053C642.929 316.123 642.788 316.204 642.653 316.286L642.341 316.502C642.009 316.758 641.709 317.044 641.447 317.358C641.102 317.754 640.865 318.215 640.755 318.706L642.984 317.569V320.092C642.978 320.175 642.949 320.257 642.902 320.329C642.854 320.401 642.788 320.463 642.708 320.509C642.561 320.584 642.439 320.509 642.439 320.368V320.281C642.439 320.227 642.396 320.206 642.341 320.233C642.314 320.249 642.292 320.271 642.276 320.297C642.261 320.322 642.251 320.35 642.249 320.379V320.471C642.249 320.731 642.457 320.834 642.708 320.704C642.844 320.626 642.956 320.522 643.037 320.398C643.118 320.275 643.165 320.137 643.174 319.994V317.471L645.39 316.345Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.021 319.881L639.935 322.988V316.773L646.021 313.66V319.881ZM640.168 322.626L645.788 319.762V314.022L640.192 316.886L640.168 322.626Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.639 316.502L646.547 319.61V313.394L652.639 310.286V316.502ZM646.786 319.247L652.4 316.383V310.644L646.786 313.513V319.247Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.723 312.165V313.735C650.705 314.015 650.613 314.287 650.454 314.53C650.296 314.772 650.075 314.979 649.811 315.132L649.431 315.327C648.929 315.582 648.519 315.37 648.519 314.862V313.291L649.633 312.75L649.388 313.335L649.866 313.091L649.217 314.829L650.276 312.712L649.792 312.956L650.043 312.539L650.723 312.165Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.792 316.838L649.455 317.011V315.046L649.792 314.872V316.838Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.627 316.762L648.47 317.731L650.723 316.578L649.627 316.762Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.172 313.156L653.086 316.264V310.048L659.172 306.94V313.156ZM653.319 315.901L658.939 313.037V307.298L653.319 310.167V315.901Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.609 312.555L653.711 315.067L656.16 309.415L658.609 312.555ZM654.17 314.537L658.119 312.517L656.129 309.989L654.17 314.537Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.939 313.031C655.939 312.964 655.958 312.899 655.994 312.84C656.031 312.781 656.083 312.732 656.147 312.696C656.276 312.631 656.362 312.696 656.362 312.815C656.361 312.882 656.341 312.948 656.303 313.007C656.266 313.066 656.212 313.115 656.147 313.151C656.025 313.216 655.939 313.156 655.939 313.031ZM656.025 312.463L655.976 310.73L656.319 310.557L656.27 312.338L656.025 312.463Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.783 229.277L533.569 238.357V256.516L515.783 247.436V229.277Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.783 229.277L533.569 238.357V238.524L515.783 229.493V229.277Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.208 223.223L533.569 238.357V256.516L563.208 241.383V223.223Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.783 229.277L533.569 238.357L563.208 223.223L545.422 214.144L515.783 229.277Z",
    fill: "#BA905E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.422 232.303L563.208 223.223L545.422 214.144V232.303Z",
    fill: "#855C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.783 229.277L509.679 222.465L539.495 207.581L545.422 214.144L515.783 229.277Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.422 214.144L552.91 208.794L570.537 217.982L563.208 223.223L545.422 214.144Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.856 228.697L515.783 229.277L533.569 238.357L524.716 237.636L506.856 228.697Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.569 238.357L563.208 223.223L571.994 223.034L541.24 238.914L533.569 238.357Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.069 248.324L535.889 252.504V244.15L544.069 239.97V248.324ZM536.201 252.017L543.75 248.162V240.457L536.201 244.312V252.017Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.516 242.504V244.61C541.491 244.985 541.367 245.35 541.155 245.675C540.942 246.001 540.647 246.277 540.291 246.484L539.777 246.743C539.104 247.09 538.553 246.808 538.553 246.121V244.015L540.053 243.246L539.722 244.031L540.334 243.706L539.465 246.04L540.891 243.197L540.242 243.527L540.573 242.986L541.516 242.504Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.267 248.779L539.82 249.007V246.37L540.267 246.137V248.779Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.047 248.676L538.485 249.976L541.522 248.427L540.047 248.676Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.898 243.83L544.718 248.005V239.651L552.898 235.476V243.83ZM545.036 247.523L552.579 243.668V235.963L545.036 239.813V247.523Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.108 243.018L545.508 246.392L548.777 238.811L552.108 243.018ZM546.151 245.677L551.459 242.97L548.777 239.575L546.151 245.677Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.526 243.663C548.526 243.572 548.552 243.483 548.601 243.404C548.651 243.324 548.722 243.257 548.808 243.208C548.979 243.121 549.089 243.208 549.089 243.37C549.088 243.46 549.062 243.548 549.013 243.626C548.964 243.705 548.893 243.771 548.808 243.82C548.636 243.906 548.526 243.831 548.526 243.663ZM548.642 242.894L548.575 240.571L549.04 240.333L548.967 242.71L548.642 242.894Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.726 239.32L553.547 243.5V235.13L561.726 230.95V239.32ZM553.859 243.013L561.408 239.158V231.453L553.859 235.308V243.013Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.287 239.028L554.991 241.735V240.939L560.287 238.237V239.028Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.492 238.118L558.879 238.432V234.382L559.492 234.068V238.118Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.036 234.388L558.341 235.254L559.265 233.262L560.036 234.388Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.54 239.629L555.928 239.938V235.888L556.54 235.574V239.629Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.079 235.898L555.383 236.765L556.308 234.767L557.079 235.898Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.974 333.595L751.787 355.967V368.751L707.974 346.379V333.595Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.974 333.595L751.787 355.967V356.146L707.974 333.823V333.595Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.091 339.984L751.787 355.967V368.751L783.091 352.773V339.984Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.974 333.595L751.787 355.967L783.091 339.984L739.272 317.617L707.974 333.595Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M764.307 330.401L733.021 346.384L726.752 343.184L758.05 327.201L764.307 330.401Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M720.495 327.201L764.307 349.584L770.577 346.384L726.752 324.006L720.495 327.201Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M764.307 349.578L764.313 355.967L770.577 352.773V346.379L764.307 349.578Z",
    fill: "#DDC8AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.474 347.564C724.285 346.449 723.085 345.052 721.634 344.316C721.462 344.229 721.291 344.159 721.132 344.094C721.006 344.046 720.877 344.004 720.746 343.969C720.394 343.862 720.017 343.835 719.65 343.893C719.434 343.929 719.236 344.024 719.084 344.165C718.932 344.306 718.835 344.486 718.805 344.678L721.53 346.07V349.156C721.53 349.346 721.383 349.421 721.199 349.329C721.103 349.273 721.024 349.197 720.966 349.109C720.909 349.021 720.875 348.922 720.868 348.82V348.712C720.866 348.676 720.853 348.641 720.832 348.61C720.81 348.579 720.781 348.552 720.746 348.533C720.734 348.526 720.721 348.522 720.706 348.521C720.692 348.52 720.678 348.523 720.666 348.53C720.653 348.536 720.643 348.545 720.637 348.557C720.631 348.568 720.628 348.581 720.629 348.593V348.701C720.638 348.876 720.695 349.045 720.794 349.196C720.893 349.347 721.032 349.474 721.199 349.568C721.511 349.725 721.762 349.595 721.762 349.281V346.189L724.474 347.564Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.252 352.697L717.801 348.907V341.327L725.252 345.117V352.697ZM718.095 348.745L724.964 352.253V345.214L718.095 341.706V348.745Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.346 356.828L725.895 353.038V345.458L733.346 349.248V356.828ZM726.189 352.876L733.058 356.384V349.346L726.189 345.837V352.876Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.001 349.129V351.051C731.001 351.674 730.499 351.934 729.887 351.62L729.421 351.381C729.096 351.195 728.826 350.944 728.632 350.647C728.438 350.351 728.327 350.018 728.307 349.676V347.748L729.672 348.447L729.372 348.853L729.948 349.151L729.164 350.466L730.456 349.199L729.844 348.902L730.15 348.701L731.001 349.129Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.868 353.683L729.452 353.471V351.067L729.868 351.279V353.683Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.66 353.379L728.246 353.114L731.001 354.527L729.66 353.379Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.366 360.922L733.915 357.131V349.519L741.366 353.309V360.922ZM734.203 356.969L741.078 360.478V353.439L734.203 349.93V356.969Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.65 359.449L734.632 356.379L737.613 352.502L740.65 359.449ZM735.219 356.33L740.056 358.799L737.607 353.211L735.219 356.33Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.38 356.698C737.38 356.541 737.491 356.476 737.638 356.552C737.717 356.595 737.783 356.656 737.83 356.728C737.876 356.8 737.9 356.881 737.901 356.964C737.901 357.121 737.797 357.191 737.638 357.11C737.56 357.065 737.496 357.004 737.451 356.933C737.406 356.861 737.382 356.78 737.38 356.698ZM737.491 356.114L737.43 353.948L737.852 354.159L737.791 356.281L737.491 356.114Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.405 365.026L741.954 361.236V353.628L749.405 357.418V365.026ZM742.242 361.073L749.117 364.582V357.543L742.242 354.034V361.073Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.089 363.418L743.27 360.954V360.234L748.089 362.697V363.418Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.366 361.853L746.809 361.566V357.879L747.366 358.166V361.853Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.862 358.961L746.319 358.171L747.158 357.213L747.862 358.961Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.679 360.478L744.121 360.196V356.503L744.679 356.79V360.478Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.174 357.586L743.632 356.801L744.47 355.843L745.174 357.586Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M733.021 346.384L733.009 352.768L726.752 349.573V343.184L733.021 346.384Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.076 338.679L492.714 311.884L525.053 328.582L473.409 355.377L441.076 338.679Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.856 286.447L466.454 299.517V351.793L440.856 338.723V286.447Z",
    fill: "#987253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.856 286.447L466.454 299.517V299.761L440.856 286.761V286.447Z",
    fill: "#89644B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.11 277.735L466.454 299.517V351.793L509.11 330.011V277.735Z",
    fill: "#B98E62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.856 286.447L466.454 299.517L509.11 277.735L483.518 264.67L440.856 286.447Z",
    fill: "#DEBB8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M500.581 273.382L457.932 295.17L457.919 312.588L449.391 308.229V290.806L492.046 269.024L500.581 273.382Z",
    fill: "#E6D3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.932 295.169L457.919 312.587L449.391 308.229V290.805L457.932 295.169Z",
    fill: "#B49B84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M207.785 469.236C216.621 469.236 223.783 466.235 223.783 462.533C223.783 458.831 216.621 455.83 207.785 455.83C198.95 455.83 191.787 458.831 191.787 462.533C191.787 466.235 198.95 469.236 207.785 469.236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.332 388.356C204.332 388.356 204.663 391.442 209.603 390.522C209.603 390.522 211.25 385.221 210.001 381.859C210.001 381.859 205.716 380.164 204.332 381.859C202.948 383.554 204.332 388.356 204.332 388.356Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.76 391.946L200.224 388.156L204.84 387.988L207.54 389.612C207.54 389.612 205.201 390.863 204.479 394.485L198.76 391.946Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.82 389.336C199.82 389.336 203.181 390.175 204.718 389.336C206.254 388.497 206.983 385.546 208.25 386.315C208.25 386.315 208.752 385.773 208.25 384.479C207.748 383.185 207.957 382.411 208.697 382.368C209.438 382.325 210.932 382.119 210.932 380.3C209.651 380.472 208.342 380.3 207.173 379.807C206.132 379.406 202.887 378.643 201.846 379.46C201.46 379.741 201.155 380.101 200.959 380.508C200.763 380.915 200.681 381.358 200.72 381.799C200.369 381.929 200.066 382.142 199.844 382.414C199.621 382.686 199.488 383.007 199.458 383.342C199.337 385.346 199.458 387.355 199.82 389.336Z",
    fill: "#5F3D37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.142 388.01C207.142 388.01 205.011 386.304 206.04 384.988C206.088 384.927 206.15 384.875 206.223 384.837C206.297 384.8 206.378 384.778 206.463 384.772C206.867 384.745 207.65 384.923 208.299 386.396L207.142 388.01Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.997 392.688C198.687 393.289 198.356 395.601 197.793 396.922C197.23 398.243 193.269 407.593 193.269 409.71C193.269 411.827 194.818 420.166 194.818 420.166C194.818 420.166 192.565 421.411 191.144 420.62C191.144 420.62 188.279 412.905 189.032 408.757C189.785 404.61 193.446 394.68 193.93 393.727C194.218 393.26 194.685 392.899 195.247 392.708C195.809 392.518 196.43 392.511 196.997 392.688Z",
    fill: "#CC2368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.114 420.599C191.03 421.46 191.143 422.327 191.444 423.149C191.769 423.804 192.327 424.348 193.033 424.697C193.739 425.046 194.555 425.181 195.357 425.082C197.101 424.833 194.818 420.144 194.818 420.144L191.114 420.599Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.622 457.508C197.622 457.508 196.85 460.995 199.624 461.049C199.624 461.049 201.222 461.661 204.118 459.804C205.695 459.788 207.262 459.573 208.771 459.165C208.771 459.165 209.867 458.342 208.446 458.007L202.869 456.68C202.869 456.68 202.434 456.837 197.622 457.508Z",
    fill: "#4F312B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.479 417.594C195.479 417.594 200.138 420.182 204.736 419.678C204.736 419.678 204.093 434.671 203.946 436.831C203.799 438.991 202.942 456.658 202.869 456.658C202.795 456.658 200.42 458.71 197.622 457.487C197.554 457.043 197.009 450.751 196.33 449.289C195.65 447.828 195.038 442.364 196.832 439.95C196.832 439.95 197.267 431.243 196.403 429.337C195.54 427.432 193.195 422.207 195.479 417.594Z",
    fill: "#1C5B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.711 391.128C199.773 391.312 200.82 391.556 201.846 391.859C203.198 392.184 204.5 392.655 205.722 393.262L204.638 396.137L198.148 392.525L198.711 391.128Z",
    fill: "#ED3481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.212 392.487C201.385 392.641 202.516 392.984 203.548 393.5C206.365 394.908 210.081 397.474 210.473 398.124C211.409 399.851 211.916 401.736 211.961 403.652C211.881 405.817 211.636 417.188 212.769 420.149C212.769 420.149 204.944 422.12 199.752 419.971C199.752 419.971 196.403 418.574 195.467 417.615C195.467 417.615 194.328 407.631 193.354 402.883C192.381 398.134 193.232 393.056 195.577 392.563C197.103 392.287 198.674 392.261 200.212 392.487Z",
    fill: "#AF1E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.426 400.268C233.426 400.268 235.789 399.288 236.212 397.864C236.634 396.44 235.961 395.054 234.816 393.955C234.816 393.955 236.898 391.588 236.334 390.863C235.771 390.137 232.048 393.971 231.755 394.556C231.461 395.14 230.53 397.653 230.53 397.653L232.073 399.818L233.426 400.268Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.989 400.23C207.326 398.2 208.826 397.485 210.473 398.124C212.12 398.763 221.199 404.128 222.657 403.419C224.114 402.71 230.524 397.658 230.524 397.658C230.524 397.658 233.126 398.324 233.426 400.273C233.426 400.273 227.365 407.761 224.01 408.075C220.655 408.389 209.224 404.881 208.526 404.128C207.828 403.376 206.72 401.892 206.989 400.23Z",
    fill: "#CC2368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.108 461.764C206.108 461.764 204.271 464.498 206.591 465.516C208.912 466.534 210.877 464.563 212.775 465.007C214.673 465.451 217.606 466.28 219.981 464.942C220.139 464.843 220.287 464.73 220.422 464.607C220.505 464.528 220.565 464.432 220.595 464.328C220.624 464.224 220.624 464.114 220.592 464.01C220.561 463.906 220.5 463.811 220.416 463.733C220.332 463.656 220.226 463.599 220.11 463.567C218.31 463.091 214.263 461.943 213.093 460.811C213.087 460.811 213.014 460.979 206.108 461.764Z",
    fill: "#4F312B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.769 420.149C212.769 420.149 213.938 435.71 213.724 439.397C213.51 443.085 212.499 446.436 212.426 449.436C212.353 452.435 213.099 460.806 213.087 460.806C213.075 460.806 209.34 463.031 206.101 461.759C206.101 461.759 206.463 454.179 205.746 451.211C205.03 448.244 205.067 442.635 207.093 440.469C207.093 440.469 203.824 431.065 202.483 429.543C201.142 428.022 198.497 424.053 199.752 419.965C203.995 421.054 208.489 421.118 212.769 420.149Z",
    fill: "#2373AD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M686.784 492.361C696.435 492.361 704.258 489.89 704.258 486.843C704.258 483.796 696.435 481.326 686.784 481.326C677.134 481.326 669.311 483.796 669.311 486.843C669.311 489.89 677.134 492.361 686.784 492.361Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.252 395.573C684.041 395.985 681.856 396.034 681.715 398.79C681.574 401.546 681.996 407.404 685.07 405.98C688.143 404.556 690.788 402.84 690.929 399.705C691.07 396.57 688.492 395.157 686.252 395.573Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.062 409.792L684.182 404.177L689.913 402.645L691.321 409.792H686.062Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.307 407.81C693.201 407.187 696.256 409.873 697.205 411.54C698.154 413.208 701.742 418.13 701.338 421.898C700.933 425.667 692.986 427.773 692.986 427.773L690.746 424.161L692.307 407.81Z",
    fill: "#C667A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.764 486.746C680.521 485.95 682.492 484.526 683.05 483.465L683.766 486.638H685.088L685.982 482.036C685.982 482.036 687.599 480.503 685.982 477.753C685.982 477.753 685.088 471.716 686.166 468.229C687.243 464.742 688.792 460.557 687.06 457.276L687.415 452.354L681.292 455.061C681.354 455.224 681.574 458.386 681.635 458.705C681.696 459.025 681.954 476.031 681.592 477.498C681.021 479.007 680.274 480.458 679.364 481.83C678.378 483.4 677.319 484.819 676.743 485.046C675.525 485.528 676.982 487.537 678.764 486.746Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.649 484.153C689.209 483.611 691.799 479.956 691.799 479.956L692.362 484.153H693.28L694.297 478.652C694.649 478.047 694.821 477.373 694.794 476.693C694.767 476.013 694.543 475.351 694.143 474.769C693.892 472.604 694.143 463.399 694.554 460.605C694.964 457.812 693.078 455.234 693.078 455.234V451.13L687.513 450.632C687.513 450.632 687.721 455.419 688.021 457.265C688.321 459.111 690.299 475.733 690.299 475.733C689.852 477.358 688.168 479.296 686.625 480.785C685.401 482.008 684.243 482.951 684.017 483.162C683.533 483.649 684.096 484.694 686.649 484.153Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.649 484.153C689.209 483.611 691.798 479.956 691.798 479.956C691.798 479.956 692.276 479.079 694.296 478.652C694.649 478.047 694.82 477.373 694.794 476.693C694.767 476.013 694.543 475.351 694.143 474.769C693.805 474.717 693.457 474.744 693.134 474.848C692.812 474.953 692.526 475.131 692.307 475.365C691.633 476.166 689.49 480.362 687.794 480.649C687.439 480.709 687.053 480.752 686.662 480.785C685.437 482.008 684.28 482.951 684.053 483.162C683.533 483.649 684.096 484.694 686.649 484.153Z",
    fill: "#2C53A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.799 479.956L692.362 484.153H693.28L694.297 478.651C692.276 479.079 691.799 479.956 691.799 479.956Z",
    fill: "#234180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.764 486.746C680.521 485.95 682.492 484.526 683.049 483.465L683.766 486.638H685.088L685.982 482.035C685.982 482.035 687.598 480.503 685.982 477.753C685.198 477.899 684.023 478.213 683.533 479.014C682.921 480.059 681.843 482.127 680.362 482.127C680.006 482.117 679.661 482.016 679.37 481.835C678.384 483.405 677.325 484.824 676.749 485.051C675.525 485.528 676.982 487.536 678.764 486.746Z",
    fill: "#2C53A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 483.465L683.717 486.638H685.039L685.933 482.035C684.788 482.172 683.742 482.681 683 483.465Z",
    fill: "#234180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.152 426.955C696.152 426.955 698.129 430.745 696.917 433.848C695.705 436.95 692.852 446.988 693.543 452.338C693.543 452.338 689.423 456.16 681.164 455.852C681.164 455.852 675.36 439.831 681.69 431.151L696.152 426.955Z",
    fill: "#173660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.407 407.572C686.349 408.265 680.276 411.611 679.358 412.726C678.439 413.842 680.098 418.417 680.711 420.848C681.323 423.279 681.978 430.155 681.69 431.135C681.403 432.115 687.813 432.944 691.799 430.404C695.784 427.865 696.152 426.939 696.152 426.939C696.392 422.798 696.289 418.646 695.845 414.518C695.105 408.265 693.886 405.725 688.407 407.572Z",
    fill: "#B0519E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.084 417.134C678.396 418.525 680.601 425.39 680.056 428.168C679.74 429.471 679.331 430.755 678.831 432.012C680.22 432.676 681.743 433.09 683.313 433.23C684.031 431.738 684.445 430.145 684.537 428.525C684.758 423.284 683.637 417.291 682.652 415.271C681.666 413.251 680.472 412.456 679.18 413.051C678.029 413.587 677.772 415.747 678.084 417.134Z",
    fill: "#C667A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.103 445.51C679.609 445.548 679.939 444.557 679.609 442.727C679.278 440.897 678.85 440.626 679.431 439.322C679.829 438.434 681.923 436.208 683.313 433.23C681.743 433.09 680.22 432.676 678.831 432.012C677.668 435.147 676.125 438.769 676.064 439.592C675.978 440.827 676.596 445.472 678.103 445.51Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.213 397.019C681.072 397.977 681.764 400.04 682.847 401.226C683.931 402.412 685.297 406.781 684.305 408.508C685.575 407.094 686.417 405.417 686.754 403.635C686.754 403.635 686.288 409.364 688.97 409.364C691.652 409.364 694.052 408.411 693.525 405.828C692.999 403.246 691.278 402.444 691.278 402.444C691.278 402.444 694.903 400.279 692.533 395.915C690.164 391.551 681.678 393.57 681.213 397.019Z",
    fill: "#52260F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26.0084 313.048C34.5091 313.048 41.4003 310.873 41.4003 308.191C41.4003 305.509 34.5091 303.334 26.0084 303.334C17.5077 303.334 10.6165 305.509 10.6165 308.191C10.6165 310.873 17.5077 313.048 26.0084 313.048Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2654 257.025C10.4634 258.195 11.8777 264.741 12.0246 265.304C10.9806 265.693 9.87639 265.941 8.74902 266.04C8.60208 265.174 7.26739 257.269 7.23065 255.953C7.19392 254.638 12.6798 246.998 13.2981 246.294C13.43 246.13 13.6044 245.996 13.8068 245.903C14.0092 245.811 14.2336 245.763 14.4613 245.763C14.6891 245.763 14.9137 245.811 15.1161 245.903C15.3184 245.996 15.4927 246.13 15.6246 246.294C16.4205 247.095 17.3696 248.898 16.9716 249.83C16.5737 250.761 12.0981 255.802 11.2654 257.025Z",
    fill: "#4F87C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.555 268.785C13.0469 269.007 12.1714 267.659 12.1714 267.659C12.1714 267.659 12.1714 270.583 11.4306 270.935C10.6897 271.287 9.08567 271.13 8.24689 270.713C7.40811 270.296 8.76109 266.116 8.76109 266.116C8.76109 266.116 8.76109 266.116 8.76109 266.04C9.88846 265.941 10.9927 265.693 12.0367 265.304C12.0343 265.318 12.0343 265.333 12.0367 265.347C12.9367 266.246 14.0632 268.558 13.555 268.785Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.598 232.352C24.3245 232.893 27.1654 232.487 25.5613 239.25C25.5613 239.25 24.8694 242.136 24.1102 242.244C23.351 242.352 21.4225 241.87 20.3021 240.452C19.1816 239.033 22.598 232.352 22.598 232.352Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.582 244.811C21.582 244.811 22.0655 242.076 23.3023 241.508L18.239 239.851L17.6267 243.852L21.582 244.811Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1389 243.533C21.0124 243.803 24.8022 245.011 26.443 246.31C28.0839 247.61 29.1063 250.236 28.4574 252.981C27.8084 255.726 27.3613 258.563 28.047 260.404C28.7328 262.245 29.4124 264.632 29.4124 264.632C29.4124 264.632 20.6756 267.41 15.7225 263.604C15.7225 263.604 16.647 259.381 15.7225 256.451C14.7981 253.522 12.5144 249.57 13.5735 246.251C14.6327 242.932 19.1389 243.533 19.1389 243.533Z",
    fill: "#3C77BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2083 260.696C41.8951 261.586 41.3474 262.397 40.6103 263.062C40.6103 263.062 32.7551 259.955 30.949 258.563C29.1428 257.172 25.6225 251.741 24.7715 250.626C23.9205 249.51 24.4224 247.664 25.0102 247.214C26.1918 246.305 26.4918 246.034 28.0714 248.043C29.651 250.052 31.9164 254.73 33.796 255.877C35.6756 257.025 42.0553 260.68 42.0553 260.68L42.2083 260.696Z",
    fill: "#4F87C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4533 265.358C45.1472 266.078 42.8267 267.199 42.6553 266.712C42.4839 266.224 43.2002 265.477 43.2002 265.477C43.2002 265.477 41.0144 264.329 40.6104 263.062C41.3474 262.397 41.8952 261.586 42.2084 260.696C42.7839 260.788 45.037 261.178 45.4533 261.914C45.9309 262.743 45.7595 264.632 45.4533 265.358Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.894 300.34C32.6927 300.928 31.3533 301.26 29.9818 301.309C29.8593 299.685 29.798 297.974 29.4123 297.135C28.6592 295.511 26.6389 293.805 25.6776 291.753C24.7164 289.701 26.0326 285.256 26.0326 285.256C26.0326 285.256 19.9102 277.757 16.7142 272.657C13.5183 267.556 15.7225 263.631 15.7225 263.631L24.7225 264.335C24.7225 264.335 30.0797 282.289 30.4042 283.891C30.7287 285.494 32.8041 298.218 33.8449 300.27C33.859 300.295 33.8754 300.318 33.894 300.34Z",
    fill: "#67481C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2901 302.658C40.6472 303.93 37.0472 303.508 35.9268 304.385C34.8064 305.262 31.9226 305.771 30.8022 304.731C30.4313 304.239 30.2196 303.666 30.1899 303.074C33.392 303.34 34.7389 302.073 35.2226 301.385C36.6308 301.867 38.5534 301.412 39.4717 301.309C40.733 301.185 41.933 301.38 41.2901 302.658Z",
    fill: "#4C3718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2044 301.385C34.7208 302.073 33.3676 303.34 30.1716 303.074C30.0798 302.533 30.0248 301.932 29.9819 301.309C31.3535 301.26 32.6929 300.928 33.8941 300.34C34.1599 300.826 34.6302 301.202 35.2044 301.385Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6002 312.014C18.6737 312.69 15.1532 313.551 13.7022 312.631C12.2512 311.71 7.16332 306.328 7.98986 305.024C8.19016 304.666 8.47286 304.349 8.81974 304.094C9.16663 303.838 9.57006 303.65 10.0042 303.54C10.8919 305.63 12.9981 306.718 14.2899 307.216C14.7001 308.841 15.4165 310.438 16.0226 310.79C17.2104 311.472 18.5328 311.353 18.6002 312.014Z",
    fill: "#4C3718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7165 286.111C18.741 296.306 15.3369 302.078 14.3083 303.437C14.2363 303.53 14.1806 303.633 14.143 303.74C13.241 303.034 12.2744 302.395 11.2532 301.829C11.2532 301.829 13.09 292.809 15.9063 289.187C18.7227 285.564 20.0879 284.888 20.0879 284.888C20.0879 284.888 17.5042 271.308 18.4042 267.627C19.3042 263.945 20.0879 264.004 20.0879 264.004L29.4247 264.638C29.4247 264.638 30.686 275.911 24.7165 286.111Z",
    fill: "#805A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.296 307.233C12.9797 306.735 10.8735 305.646 10.0103 303.556L11.2348 301.824C12.256 302.389 13.2226 303.028 14.1245 303.735C13.8245 304.504 13.9593 305.885 14.296 307.233Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4677 235.184C25.733 237.214 23.9329 236.905 23.9819 238.286C24.0309 239.667 22.5616 241.492 19.9044 241.789C19.9044 241.789 17.8901 251.573 19.9044 255.953C19.7085 255.796 11.6328 249.304 16.7022 240.252L16.7941 239.169C16.7941 239.169 14.8716 235.281 16.7022 232.606C18.5328 229.932 21.8329 231.069 21.8329 231.069C25.1268 232.206 27.2024 233.159 26.4677 235.184Z",
    fill: "#87574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5961 241.015L19.8798 241.789C18.8145 240.36 16.6716 240.241 16.6716 240.241L16.7634 239.158C19.9104 239.607 20.5961 241.015 20.5961 241.015Z",
    fill: "#4F332E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M865.047 339.389C873.547 339.389 880.439 337.214 880.439 334.532C880.439 331.85 873.547 329.675 865.047 329.675C856.546 329.675 849.655 331.85 849.655 334.532C849.655 337.214 856.546 339.389 865.047 339.389Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.516 312.804C854.749 315.008 856.928 327.748 855.998 329.54C855.879 329.736 855.733 329.917 855.563 330.081C858.33 330.509 860.032 330.276 861.024 329.951C860.957 329.746 860.89 329.529 860.822 329.307C860.277 327.52 862.377 320.287 862.849 317.601C862.968 316.791 862.879 315.967 862.588 315.192C862.296 314.416 861.81 313.709 861.165 313.124C862.181 310.286 860.498 301.353 860.437 301.012C860.577 301.369 865.041 312.804 865.653 314.499C866.265 316.193 871.88 326.486 873.52 328.549C873.795 328.862 873.981 329.23 874.062 329.62C874.143 330.01 874.117 330.411 873.986 330.791C874.967 330.84 875.94 330.606 876.757 330.124C877.574 329.641 878.192 328.936 878.516 328.116C878.437 328.013 878.357 327.905 878.265 327.796C876.71 325.799 875.933 320.704 875.62 317.948C875.308 315.192 872.039 312.23 872.039 312.23C872.039 312.23 871.494 303.827 870.814 299.279C870.135 294.731 868.69 294.011 868.69 294.011L853.451 291.666C851.332 295.992 854.277 310.6 854.516 312.804Z",
    fill: "#89211B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.071 338.766C875.32 339.8 876.006 334.906 877.059 333.736C878.112 332.567 879.122 332.431 879.667 331.397C880.212 330.363 879.863 329.876 878.516 328.148C878.192 328.969 877.574 329.674 876.757 330.156C875.94 330.639 874.967 330.873 873.986 330.823C873.661 331.787 872.798 332.512 872.663 332.924C872.424 333.601 866.822 337.732 871.071 338.766Z",
    fill: "#4E4019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.755 334.012C851.553 335.734 854.357 334.153 855.759 333.53C857.161 332.908 857.632 333.736 859.873 333.189C861.838 332.702 861.508 331.478 861.024 329.973C860.032 330.298 858.33 330.514 855.563 330.103C853.867 331.841 848.755 334.012 848.755 334.012Z",
    fill: "#4E4019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.555 283.231C848.988 283.832 850.131 284.867 850.775 286.149C851.633 285.676 852.417 285.107 853.108 284.454C854.332 282.987 854.541 275.293 854.859 272.943C855.177 270.594 854.926 267.816 853.108 268.108C850.898 268.466 850.047 272.727 850.047 274.194C850.047 275.662 849.783 280.74 848.461 282.207C848.185 282.5 847.885 282.852 847.555 283.231Z",
    fill: "#4D67AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.789 291.493C834.955 292.154 838.598 294.2 840.012 292.814C841.213 291.727 842.529 290.744 843.943 289.88C843.943 289.88 848.014 287.844 850.775 286.149C850.131 284.867 848.988 283.832 847.555 283.231C846.183 284.785 844.206 286.821 841.818 287.173C838.83 287.611 836.528 286.875 836.277 287.681C836.026 288.488 839.014 288.856 839.014 288.856C839.014 288.856 834.624 290.833 834.789 291.493Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.71 265.932C859.408 265.515 853.696 266.879 852.324 268.049C850.953 269.218 850.953 275.954 852.024 278.596C853.096 281.238 852.202 290.134 852.998 291.233C853.794 292.332 861.336 297.048 868.708 294.032C869.62 293.633 870.342 292.959 870.744 292.131C871.145 291.304 871.201 290.377 870.9 289.517C869.981 286.236 869.675 271.438 868.732 270.025C867.79 268.612 864.624 266.463 861.71 265.932Z",
    fill: "#3D56A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.187 274.996C866.185 276.463 871.31 282.5 871.071 284.097C870.737 285.21 870.236 286.279 869.583 287.275C871.097 287.531 872.478 288.21 873.52 289.214C875.357 287.275 876.943 285.342 877.053 284.519C877.292 282.716 871.812 273.799 870.649 272.521C869.485 271.243 868.604 268.996 866.755 269.874C866.263 270.111 865.831 270.435 865.484 270.824C865.137 271.213 864.883 271.661 864.736 272.139C864.59 272.617 864.554 273.117 864.632 273.608C864.709 274.099 864.898 274.571 865.187 274.996Z",
    fill: "#4D67AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.337 298.277C865.524 297.438 867.183 295.029 868.273 294.271C870.133 292.678 871.885 290.989 873.52 289.214C872.478 288.21 871.097 287.531 869.583 287.275C868.206 289.614 866.253 292.278 865.475 292.489C864.251 292.825 861.832 292.029 861.447 292.657C861.061 293.285 863.816 294.043 863.816 294.043C863.816 294.043 860.02 295.846 859.879 296.685C859.739 297.525 863.149 299.117 864.337 298.277Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.987 256.246C857.975 256.105 855.428 256.392 855.189 258.493C854.951 260.593 854.014 265.705 856.947 266.403C859.879 267.101 863.02 264.676 863.069 260.68C863.118 256.684 860.987 256.246 860.987 256.246Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.314 262.201C863.314 262.201 861.269 260.691 861.269 258.758C861.269 258.758 854.92 259.906 854.075 255.509C855.566 255.597 857.061 255.394 858.453 254.914C860.902 254.102 864.275 254.188 864.3 256.403C864.3 256.403 866.247 256.89 866.247 259.11C866.246 260.033 865.997 260.942 865.52 261.763C865.043 262.584 864.352 263.293 863.504 263.831L863.314 262.201Z",
    fill: "#543631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.724 262.039V266.912C863.24 267.677 862.46 268.261 861.528 268.56C860.596 268.858 859.574 268.85 858.649 268.536C858.399 268.394 858.186 268.207 858.024 267.987C857.863 267.766 857.756 267.518 857.712 267.258C857.657 266.473 857.712 263.344 857.712 263.344L863.724 262.039Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.255 261.877C862.255 261.877 863.29 260.285 864.636 260.983C865.983 261.682 864.759 263.69 862.255 263.198V261.877Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M631.633 156.583C640.79 156.583 648.213 154.242 648.213 151.353C648.213 148.465 640.79 146.123 631.633 146.123C622.476 146.123 615.053 148.465 615.053 151.353C615.053 154.242 622.476 156.583 631.633 156.583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.129 142.127L631.633 144.834C631.633 144.834 631.596 146.042 635.386 146.307C636.049 146.412 636.693 146.594 637.302 146.848C637.835 147.146 640.7 147.855 641.533 147.022C642.366 146.188 640.204 145.219 639.604 145.051C639.004 144.883 635.545 143.324 635.545 142.344L632.129 142.127Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.855 106.268C641.043 107.318 641.894 113.074 639.243 127.232C636.592 141.391 635.735 142.647 635.735 142.647C635.735 142.647 633.359 143.188 631.829 142.143C631.829 142.143 631.492 132.397 632.79 128.066C632.79 128.066 631.639 112.808 631.792 108.904L639.855 106.268Z",
    fill: "#223066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.314 147.899C622.082 148.911 621.604 150.205 622.161 151.483C622.776 152.684 623.25 153.938 623.576 155.224C623.621 155.628 623.761 156.019 623.989 156.371C624.217 156.723 624.526 157.028 624.897 157.267C625.267 157.506 625.691 157.672 626.14 157.756C626.588 157.84 627.052 157.839 627.5 157.753C630.188 157.417 628.896 155.046 627.935 153.21C627.086 151.457 626.605 149.582 626.514 147.677L622.314 147.899Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.363 107.8C624.69 107.6 622.664 114.043 623.123 127.59C623.123 127.59 621.378 133.437 621.69 135.538C622.002 137.639 622.168 146.258 621.69 148.24C621.69 148.24 623.784 149.989 626.68 148.24C626.68 148.24 630.108 133.556 631.161 130.703C632.215 127.849 637.419 113.334 636.133 108.266C636.133 108.266 628.37 108.672 625.363 107.8Z",
    fill: "#223066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.763 83.6736L625.192 84.7835C625.192 84.7835 623.869 86.3537 619.18 88.0755C619.18 88.0755 617.282 89.5969 619.669 93.2732C622.057 96.9496 624.133 101.725 624.8 104.643C625.468 107.562 623.912 108.082 624.8 108.867C625.688 109.652 638.202 112.348 641.123 105.856C641.06 105.115 640.82 104.393 640.419 103.739C639.751 102.683 640.284 85.3304 637.143 82.7261C633.977 82.29 630.737 82.6174 627.763 83.6736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.18 88.0755C617.466 88.8389 612.2 94.9625 611.906 96.289C611.906 96.289 611.808 92.499 610.786 89.9813C610.786 89.9813 609.384 90.9775 608.061 90.761C608.061 90.761 606.935 100.507 610.835 101.232C614.735 101.958 621.592 95.1141 622.345 92.7101C622.97 90.7177 620.882 87.3174 619.18 88.0755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.131 82.7044C638.9 82.9264 648.678 88.2162 648.678 88.2162C650.302 85.8829 652.195 83.7054 654.329 81.719C654.569 82.1752 654.942 82.5663 655.41 82.8519C655.879 83.1375 656.425 83.3072 656.992 83.3433C656.992 83.3433 653.509 92.7318 649.811 92.7318C646.113 92.7318 637.853 90.6527 636.782 87.9726C635.71 85.2925 636.078 82.5691 637.131 82.7044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.341 81.7298C654.341 81.7298 654.188 79.3367 654.659 78.4812C655.131 77.6257 656.233 76.4075 656.649 76.6403C657.066 76.8731 656.251 78.5787 656.251 78.5787C656.78 78.1177 657.242 77.6013 657.629 77.041C657.819 76.5916 658.425 75.1839 659.013 75.3517C659.6 75.5196 661.302 77.864 660.733 79.2013C660.164 80.5387 658.247 83.0726 657.004 83.3433C656.428 83.3452 655.864 83.1918 655.388 82.9036C654.913 82.6154 654.547 82.206 654.341 81.7298Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.284 86.8248C610.284 86.8248 609.427 92.7102 606.837 96.1104C606.837 96.1104 599.006 94.3237 595.204 94.8814C595.204 94.8814 599.031 88.2759 598.731 86.0614C598.431 83.8469 596.606 77.6908 596.606 77.6908C596.606 77.6908 604.272 75.054 609.463 76.3859C609.427 76.3859 611.569 81.5621 610.284 86.8248Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.212 74.0631C631.559 73.4837 633.335 75.016 633.721 75.7307C634.106 76.4454 634.027 82.7693 632.563 83.4299C632.563 83.4299 626.055 84.5507 625.32 79.6398C624.586 74.729 627.212 74.0631 627.212 74.0631Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.927 80.2354C626.44 79.8976 626.853 79.4557 627.132 78.9468C627.412 78.4379 627.548 77.8771 627.531 77.3117C627.531 77.3117 632.429 77.5986 634.67 75.0701C634.67 75.0701 630.512 70.9444 625.437 73.4458C620.361 75.9472 624.378 82.4445 625.639 81.9897L625.927 80.2354Z",
    fill: "#52260F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.498 83.6736L625.614 82.0005L625.7 79.6128L632.827 80.6415C632.827 80.6415 630.99 84.4316 631.339 85.6281C631.363 85.6281 628.449 86.6569 625.498 83.6736Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.498 83.6736C625.26 83.8218 625.068 84.0215 624.942 84.2537C624.815 84.4859 624.758 84.7428 624.776 85.0001C624.776 85.0001 627.047 87.6586 629.41 88.0755C629.41 88.0755 629.459 86.4511 630.145 85.796C628.409 85.4694 626.804 84.7364 625.498 83.6736Z",
    fill: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.363 85.6281C631.363 85.6281 632.496 86.1696 632.704 86.8247C632.704 86.8247 633.206 84.8376 631.535 84.0146C631.37 84.5392 631.312 85.0856 631.363 85.6281Z",
    fill: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.17 85.796L631.364 85.6282C631.874 85.8042 632.304 86.1238 632.588 86.5378L632.398 87.5394L630.819 87.9509L629.527 87.4799C629.555 86.8758 629.778 86.2914 630.17 85.796Z",
    fill: "#BA202A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.788 87.9509C632.701 93.0036 633.505 98.333 633.157 103.653L634.67 105.022L636.023 103.052C636.023 103.052 634.345 92.6344 632.349 87.5232L630.788 87.9509Z",
    fill: "#C9202C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.588 80.1001C626.588 80.1001 625.296 78.4217 624.261 79.6778C623.563 80.5279 625.486 81.9681 626.937 81.6974L626.588 80.1001Z",
    fill: "#FAC2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.804 89.9813C610.804 89.9813 611.588 87.3066 611.159 86.646C610.731 85.9855 608.404 84.372 607.737 84.8972C607.069 85.4224 609.231 86.7164 609.286 87.063C609.341 87.4095 609.414 90.6635 609.414 90.6635C609.957 90.5969 610.453 90.3536 610.804 89.9813Z",
    fill: "#FAC2B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_1002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 903,
    height: 539,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCover);
export default __webpack_public_path__ + "static/media/loginCover.57665b534a6f5b1a80dc9a06c3a23625.svg";
export { ForwardRef as ReactComponent };